const COL = 16;
const HEX = {
  'Black':'#1c1c1e','White':'#f2f2ef','Red':'#b4242c','Blue':'#1f4e8c','Metallic':'#adb3ba',
  'Green':'#2c6b3f','Orange':'#d4691e','Yellow':'#e0b520','Beige':'#d8cbb2','Gray':'#7d848c',
  'Purple':'#5b3a80','Pink':'#cf6f96','Stealth Black':'#232629','Desert Sand':'#c2ab86',
  'Ghost White':'#e6e8e6','Gun Metal Grey':'#5a6068','Gold':'#c29c46'
};

/* Metallic is a bare-steel finish, so the product page shows it as a highlight
   rather than a flat fill.  Everything else is a solid colour. */
const GRAD = {
  'Metallic':'linear-gradient(145deg,#eef0f2 4%,#a7aeb6 52%,#d6dade 96%)',
  'Gold':'linear-gradient(145deg,#ecd591 4%,#b58f3a 52%,#dbc06e 96%)'
};
/* Swatch order copied from the pegboard product page so the planner reads the
   same left-to-right.  Anything not on that row (the Signature Series finishes)
   follows in catalogue order. */
const SWATCH_ORDER = ['Metallic','Black','Blue','Yellow','Orange','Gray',
                      'Red','White','Green','Beige','Gold','Purple','Pink'];
/* Kit accessory bundles only come in these four finishes; a fixed order keeps
   every kit's swatch row reading the same. */
const ACC_ORDER = ['Black','White','Red','Blue'];

const D = window.PLANNER_DATA;
/* Kit surfaces (inline strip, See all kits, kit tiers, kit cross-sell) sit
   behind a theme switch: the section's show_kits setting emits
   window.PLANNER_SHOW_KITS. Absent (the local prototype) means on. Off hides
   every kit surface but leaves the kit code and catalogue data in place. */
const KITS_ON = window.PLANNER_SHOW_KITS !== false;
/* face: 'dots' = Slots & Dots panels (standard and Signature Series alike);
   'slots' = the slotted-only wall-storage line (10-P / 10-GP SKUs, no peg
   holes). The palettes overlap, so every pool must filter by face first. */
const state = { color:'Black', face:'dots', dims:null, tier:0, tiers:[],   // dims: applied wall size in inches, null until committed
                budget:{min:null, max:null},   // null = no limit
                off:new Set(),                 // panel base SKUs the user switched off
                vb:{on:false, h:32, n:1, color:null},  // 3D V-Bracket modules; color null = follow wall
                kitAccessory:new Map(),        // kit handle -> chosen accessory finish
                accWarn:null,                  // kit handle Add to cart was tried on with no accessory finish
                kitPick:null,                  // kit handle to build around; null = automatic
                pick:null,                     // fill height chosen from the full list
                combosOpen:false };

/* A 2-pack is the SAME panel as its single, just packaged cheaper, so both share
   one size key.  Customers pick sizes; whether a pack or singles is better value
   is worked out by the optimiser, not asked of them. */
function pieceW(p){ return (p.cols*COL)/(p.pack||1); }
function sizeKey(p){ return pieceW(p) + 'x' + p.height; }

/* Wall Control names panels height-first, e.g. "32in x 16in" for the upright
   board, so match that and say which way up it hangs. */
function sizeName(h, w){
  const orient = h > w ? 'Vertical' : h < w ? 'Horizontal' : '';
  return `${h}in &times; ${w}in${orient ? ' ' + orient : ''}`;
}
const inBudget = c => (state.budget.max==null || c <= state.budget.max) &&
                      (state.budget.min==null || c >= state.budget.min);

/* ---------------------------------------------------------------- optimizer
   Bands are 1 or 2 columns wide.  For a band we precompute the cheapest way to
   fill EXACTLY t inches of height.  Filling every band to the same height t
   gives a clean rectangle, and sweeping t yields a coverage/price frontier. */
function bandCosts(panels, wide, maxH){
  /* 30-P-3216 (16x32 vertical) is the flagship size - the widest colour range
     and the most kit combinations - so wherever two fills come out at the same
     price, the DP's strict `<` keeps whichever panel it saw first: sort the
     flagship (and its 2-pack, which shares the 16x32 size key) to the front. */
  const opts = panels.filter(p => p.cols === wide)
    .sort((a,b)=> (sizeKey(b)==='16x32') - (sizeKey(a)==='16x32'));
  const cost = new Array(maxH+1).fill(Infinity);
  const pick = new Array(maxH+1).fill(null);
  cost[0] = 0;
  for(let t=1;t<=maxH;t++){
    for(const p of opts){
      if(p.height<=t && cost[t-p.height]+p.price < cost[t]){
        cost[t] = cost[t-p.height]+p.price;
        pick[t] = p;
      }
    }
  }
  return {cost, pick};
}

function solveRegion(panels, cols, wallH){
  if(cols < 1 || wallH < 1) return null;
  const b1 = bandCosts(panels,1,wallH), b2 = bandCosts(panels,2,wallH);

  const frontier = [];
  for(let t=1;t<=wallH;t++){
    if(!isFinite(b1.cost[t]) && !isFinite(b2.cost[t])) continue;
    // cheapest arrangement of `cols` columns, every band filled to exactly t
    const f = new Array(cols+1).fill(Infinity), how = new Array(cols+1).fill(0);
    f[0]=0;
    for(let c=1;c<=cols;c++){
      if(isFinite(b1.cost[t]) && f[c-1]+b1.cost[t] < f[c]){ f[c]=f[c-1]+b1.cost[t]; how[c]=1; }
      if(c>=2 && isFinite(b2.cost[t]) && f[c-2]+b2.cost[t] < f[c]){ f[c]=f[c-2]+b2.cost[t]; how[c]=2; }
    }
    if(!isFinite(f[cols])) continue;
    frontier.push({height:t, cost:f[cols], how, cols, covered:cols*COL*t});
  }
  if(!frontier.length) return null;

  // keep only Pareto-optimal points: no cheaper option covers at least as much
  frontier.sort((a,b)=>a.cost-b.cost || b.height-a.height);
  const pareto=[]; let best=-1;
  for(const f of frontier){ if(f.height>best){ pareto.push(f); best=f.height; } }
  return {pareto, b1, b2, cols};
}

/* Frontier pickers.  "Balanced" is the most coverage still within 15% of the
   best cost-per-square-foot, which is what stops the optimiser paying triple
   for the last few inches with 12in tiles. */
const byValue = p => p.pareto.reduce((a,b)=> b.cost/b.covered < a.cost/a.covered ? b : a);
const byMax   = p => p.pareto[p.pareto.length-1];
function balanced(p){
  const v = byValue(p);
  return p.pareto.filter(x => x.cost/x.covered <= v.cost/v.covered*1.15).pop() || v;
}

function layout(plan, t){
  // rebuild the actual panel placements for fill height t
  const {b1,b2,cols} = plan;
  const f = new Array(cols+1).fill(Infinity), how = new Array(cols+1).fill(0);
  f[0]=0;
  for(let c=1;c<=cols;c++){
    if(isFinite(b1.cost[t]) && f[c-1]+b1.cost[t] < f[c]){ f[c]=f[c-1]+b1.cost[t]; how[c]=1; }
    if(c>=2 && isFinite(b2.cost[t]) && f[c-2]+b2.cost[t] < f[c]){ f[c]=f[c-2]+b2.cost[t]; how[c]=2; }
  }
  const bands=[]; let c=cols;
  while(c>0 && how[c]){ bands.push(how[c]); c-=how[c]; }   // how[c]=0 only if infeasible
  bands.reverse();

  const placed=[]; let x=0;
  for(const w of bands){
    const src = w===1?b1:b2;
    let rem=t, y=0;
    while(rem>0){
      const p=src.pick[rem];
      placed.push({panel:p, x, y, w:w*COL, h:p.height});
      y+=p.height; rem-=p.height;
    }
    x+=w*COL;
  }
  return placed;
}

/* -------------------------------------------------------------- split solve
   With V-Bracket columns reserved mid-wall, the free columns are no longer one
   contiguous block.  Every segment is filled to the SAME height t (one clean
   rectangle look), and one per-t column DP serves all segments at once: f[c]
   is the cheapest exact fill of c columns, whatever segment they belong to.

   A V module is just another panel in its column: the strip above it up to
   the fill line t is free wall, so it joins the fill - an exact fill when one
   exists, otherwise the tallest partial one (a 12in tile in the 16in gap
   above a 32in module on a 48in wall) - stacked directly on the module the
   way panels stack on each other (owner call, Sep 15 2026; it used to hang
   flush with the top line, leaving a gap over the module).  Adjacent V
   columns share their strip, so a 2-column panel can bridge them, and a
   module may borrow the free column beside it (vConfigs) so a 32in-wide
   panel can sit across the module and a flat panel, exactly as it would
   across two flat panels in the same rows. */
function vtopRuns(cols){
  const runs=[];
  for(const c of cols){
    const last = runs[runs.length-1];
    if(last && last.x0 + last.cols === c) last.cols++;
    else runs.push({x0:c, cols:1});
  }
  return runs;
}
function vtopTables(b1, b2, widths, H){
  // per band width: the tallest reachable fill at or under every gap, and its cost
  const tab = {};
  for(const w of new Set(widths)){
    const best = new Array(H+1).fill(null);
    for(let t=1;t<=H;t++){
      const f = new Array(w+1).fill(Infinity); f[0]=0;
      for(let c=1;c<=w;c++){
        if(isFinite(b1.cost[t]) && f[c-1]+b1.cost[t] < f[c]) f[c]=f[c-1]+b1.cost[t];
        if(c>=2 && isFinite(b2.cost[t]) && f[c-2]+b2.cost[t] < f[c]) f[c]=f[c-2]+b2.cost[t];
      }
      best[t] = isFinite(f[w]) ? {h:t, cost:f[w]} : best[t-1];
    }
    tab[w] = best;
  }
  return tab;
}
const vtopFill = (vtop, run, gap) => gap >= 1 ? vtop.tab[run.cols][gap] : null;
/* Pairing configurations.  A module may borrow the free column beside it so a
   2-column panel can sit across the module and that column, exactly as it
   would across two flat panels; the borrowed column stacks flat panels to the
   module height underneath.  Three candidates - no pairing, every module
   borrowing to its right (else left), every module borrowing to its left
   (else right) - and the frontier keeps whichever wins at each fill line. */
function vConfigs(vb, totCols){
  const build = pref => {
    const taken = new Set(vb.cols), pairs = [];
    for(const c of vb.cols){
      const nc = pref.map(d => c+d).find(x => x >= 0 && x < totCols && !taken.has(x));
      if(nc !== undefined){ taken.add(nc); pairs.push({c, nc}); }
    }
    const segs = []; let run = null;
    for(let x=0;x<totCols;x++){
      if(taken.has(x)){ run = null; continue; }
      if(!run){ run = {x0:x, cols:0}; segs.push(run); }
      run.cols++;
    }
    return {pairs, segs, runs: vtopRuns(vb.cols.filter(c => !pairs.some(p => p.c === c))),
            key: pairs.map(p => p.c+':'+p.nc).join(',')};
  };
  const out = [build([])];
  for(const cfg of [build([1,-1]), build([-1,1])])
    if(cfg.pairs.length && !out.some(o => o.key === cfg.key)) out.push(cfg);
  return out;
}
/* 1 when a frontier point leaves the strip above some module empty. */
function vBare(plan, f){
  const vt = plan.vtop;
  if(!vt || f.height <= vt.h) return 0;
  const C = plan.cfgs[f.cfg ?? plan.cfgAt[f.height] ?? 0];
  const gap = f.height - vt.h;
  return (C.runs.some(r => !vtopFill(vt, r, gap)) || (C.pairs.length && !vt.tab[2][gap])) ? 1 : 0;
}

function solveSplit(panels, segs, H, vb){
  // no free segment at all (every column is a V module) still leaves the
  // strips above the modules to fill
  if(!segs.length && !vb) return null;
  const b1 = bandCosts(panels,1,H), b2 = bandCosts(panels,2,H);
  const freeCols = segs.reduce((a,s)=>a+s.cols,0);
  // pairing needs the borrowed column to stack exactly to the module height
  const cfgs = vb ? vConfigs(vb, freeCols + vb.n).filter(c => !c.pairs.length || isFinite(b1.cost[vb.h]))
                  : [{pairs:[], segs, runs:[], key:''}];
  const maxC = Math.max(0, ...cfgs.flatMap(c => c.segs.map(s=>s.cols)));
  const vtop = vb ? {h:vb.h, n:vb.n, cols:vb.cols, runs:vtopRuns(vb.cols)} : null;
  if(vtop) vtop.tab = vtopTables(b1, b2,
      [...cfgs.flatMap(c => c.runs.map(r=>r.cols)), ...(cfgs.some(c=>c.pairs.length) ? [2] : [])], H);
  const frontier = [], cfgAt = [];
  for(let t=1;t<=H;t++){
    if(maxC && !isFinite(b1.cost[t]) && !isFinite(b2.cost[t])) continue;
    const f = new Array(maxC+1).fill(Infinity); f[0]=0;
    for(let c=1;c<=maxC;c++){
      if(isFinite(b1.cost[t]) && f[c-1]+b1.cost[t] < f[c]) f[c]=f[c-1]+b1.cost[t];
      if(c>=2 && isFinite(b2.cost[t]) && f[c-2]+b2.cost[t] < f[c]) f[c]=f[c-2]+b2.cost[t];
    }
    // every pairing configuration is a candidate at this fill line; the
    // frontier keeps them all and each point remembers which one it is
    let bestPt = null;
    cfgs.forEach((C, ci) => {
      if(C.pairs.length && t < vtop.h) return;   // a borrowed column stacks to the module top
      let cost=0, cols=0;
      for(const s of C.segs){
        if(!isFinite(f[s.cols])) return;
        cost += f[s.cols]; cols += s.cols;
      }
      // the V columns join the fill: above each run of unpaired modules the
      // strip up to the same height t takes the tallest fill that fits
      let vCost=0, vCov=0;
      if(vtop && t > vtop.h)
        for(const r of C.runs){
          const fl = vtopFill(vtop, r, t - vtop.h);
          if(fl){ vCost += fl.cost; vCov += r.cols*COL*fl.h; }
        }
      // a paired module: the borrowed column stacks to the module height and
      // a 2-column fill sits across both, so a 32in-wide panel bridges them
      for(const pr of C.pairs){
        vCost += b1.cost[vtop.h]; vCov += COL*vtop.h;
        const fl = t > vtop.h ? vtop.tab[2][t - vtop.h] : null;
        if(fl){ vCost += fl.cost; vCov += 2*COL*fl.h; }
      }
      if(!cols && !vCov) return;    // all-V wall with nothing above the modules yet
      const pt = {height:t, cost:cost+vCost, covered:cols*COL*t + vCov, cfg:ci};
      frontier.push(pt);
      if(!bestPt || pt.covered > bestPt.covered ||
         (pt.covered === bestPt.covered && pt.cost < bestPt.cost)) bestPt = pt;
    });
    if(bestPt) cfgAt[t] = bestPt.cfg;   // fallback for callers that only know the height
  }
  if(!frontier.length) return null;
  const all = frontier.slice();     // full list incl. dominated points - the
                                    // cohesive picker may pay a little extra
                                    // for a build the frontier would prune
  // Pareto on COVERED AREA, not fill height: with V-top fills a taller fill can
  // cover less (the strip above a module may be unfillable at some heights)
  frontier.sort((a,b)=>a.cost-b.cost || b.covered-a.covered);
  const pareto=[]; let best=-1;
  for(const f of frontier){ if(f.covered>best){ pareto.push(f); best=f.covered; } }
  return {pareto, frontier:all, b1, b2, segs, vtop, cfgs, cfgAt, cols: freeCols};
}
function layoutPlan(plan, t, cfg){
  if(!plan.segs) return layout(plan, t);
  const C = plan.cfgs ? plan.cfgs[cfg ?? plan.cfgAt[t] ?? 0] : {segs:plan.segs, runs:[], pairs:[]};
  const out=[];
  for(const s of C.segs)
    for(const p of layout({b1:plan.b1, b2:plan.b2, cols:s.cols}, t))
      out.push({...p, x:p.x + s.x0*COL});
  const vt = plan.vtop;
  if(vt && t > vt.h)
    for(const r of C.runs){
      const fl = vtopFill(vt, r, t - vt.h);
      if(!fl) continue;
      // sits on the module like the next panel up: any shortfall is open
      // wall at the top of the column
      for(const p of layout({b1:plan.b1, b2:plan.b2, cols:r.cols}, fl.h))
        out.push({...p, x:p.x + r.x0*COL, y:p.y + vt.h});
    }
  for(const pr of C.pairs){
    // the borrowed column stacks flat panels to the module's height ...
    for(const p of layout({b1:plan.b1, b2:plan.b2, cols:1}, vt.h))
      out.push({...p, x:p.x + pr.nc*COL});
    // ... and a 2-column fill sits across the module and that column
    const fl = t > vt.h ? vt.tab[2][t - vt.h] : null;
    if(fl)
      for(const p of layout({b1:plan.b1, b2:plan.b2, cols:2}, fl.h))
        out.push({...p, x:p.x + Math.min(pr.c, pr.nc)*COL, y:p.y + vt.h});
  }
  return out;
}

/* Cohesion-aware max coverage: chasing the absolute maximum can produce ragged
   builds - a lone column of stacked 12in tiles beside uniform rows, or a bare
   strip above a V module.  Among frontier points within 6% of the best
   coverage, prefer no bare V-top, then the fewest distinct panel sizes
   (uniform rows read as a designed wall), then coverage itself. */
function byMaxCohesive(plan, extra=0){
  const top = byMax(plan);
  let best = null, bBare = 9, bSizes = 99, bCov = -1;
  // scan the FULL frontier: the tidy build may be cost-dominated (a bit dearer
  // for a bit less area) and so pruned from the pareto set - allow up to 10%
  // over the max-coverage point's price to buy the cohesive layout
  for(const f of (plan.frontier || plan.pareto)){
    if(f.covered < top.covered * 0.94) continue;
    if(f.cost > top.cost * 1.10) continue;
    if(!inBudget(f.cost + extra)) continue;
    const bare = vBare(plan, f);
    const sizes = new Set(layoutPlan(plan, f.height, f.cfg).map(p=>sizeKey(p.panel))).size;
    if(!best || bare < bBare || (bare === bBare && (sizes < bSizes ||
       (sizes === bSizes && f.covered > bCov)))){
      best = f; bBare = bare; bSizes = sizes; bCov = f.covered;
    }
  }
  return best || top;
}

/* ------------------------------------------------------------- kit-first plan
   Anchor a stock kit in the bottom-left, then fill the two rectangles it leaves
   (above it, and beside it) with loose panels.  Ranked on coverage first, then
   on accessories per dollar - the point of this tier is what you get, not the
   lowest price. */
/* "Start from a kit": when the customer names the kit they want to work with,
   every kit-first planner considers only that kit — it stops competing with the
   rest of the catalogue and the layout is built around it instead. */
function kitPool(){
  if(!KITS_ON || state.face === 'slots') return [];   // every kit ships Slots & Dots panels
  const offered = D.kits.filter(kitOffered);
  return state.kitPick ? offered.filter(k => k.handle === state.kitPick) : offered;
}

function planKitFirst(panels, W, H, extraCost=0, extraCov=0, fullArea=null){
  const cols = Math.floor(W/COL);
  let best = null;

  for(const kit of kitPool()){
    const kv = kitVariant(kit);
    // never recommend a kit that isn't sold in the customer's pegboard colour
    if(!kv) continue;
    const kc = kit.width/COL;
    if(kc > cols || kit.height > H) continue;
    if(state.budget.max != null && kv.price > state.budget.max) continue;

    const aboveH = H - kit.height, besideC = cols - kc;
    const above  = aboveH  >= 8 ? solveRegion(panels, kc, aboveH)   : null;
    const beside = besideC >= 1 ? solveRegion(panels, besideC, H)   : null;
    // this tier is the maximum-coverage option, so fill the leftover
    // rectangles for coverage too rather than for value
    const aPick = above  ? byMax(above)  : null;
    const bPick = beside ? byMax(beside) : null;

    const cost = kv.price + (aPick?aPick.cost:0) + (bPick?bPick.cost:0) + extraCost;
    const covered = kit.width*kit.height
                  + (aPick?aPick.covered:0) + (bPick?bPick.covered:0) + extraCov;
    const cand = {
      name:'Kit + panels', sub:'max coverage', kit, kitVariant:kv, cost, covered,
      pct: 100*covered/(fullArea || (W*H)),
      accessories: kit.accessories,
      above: above && aPick ? {region:above, t:aPick.height} : null,
      beside: beside && bPick ? {region:beside, t:bPick.height} : null,
    };
    // more wall covered wins; between equals, more accessories per dollar wins
    const score = c => [c.covered, (c.accessories||0)/c.cost];
    if(!inBudget(cand.cost)) continue;
    if(!best) { best = cand; continue; }
    const [ac,aa] = score(cand), [bc,ba] = score(best);
    if(ac > bc || (ac === bc && aa > ba)) best = cand;
  }
  return best;
}

/* Anchor fallback: with V columns splitting the wall, the kit anchors in the
   LARGEST free segment; the other segments get their max-coverage panel fill.
   Only used for an explicitly picked kit whose panels can't ride the normal
   fill (the slotted-only jewelry panel, or no qualifying fill height). */
function planKitAnchorSeg(panels, segs, H, vb, extraCost=0, extraCov=0, fullArea=null){
  if(!segs.length) return null;
  const main = segs.reduce((a,b)=> b.cols>a.cols ? b : a);
  let oCost=0, oCov=0; const oFills=[];
  for(const s of segs){
    if(s === main) continue;
    const r = solveRegion(panels, s.cols, H);
    if(r){ const m = byMax(r);
           oCost += m.cost; oCov += m.covered;
           oFills.push({x0:s.x0, region:r, t:m.height}); }
  }
  const best = planKitFirst(panels, main.cols*COL, H, extraCost+oCost, extraCov+oCov, fullArea);
  if(best){ best.kitX = main.x0*COL; best.oFills = oFills; best.kitAnchor = true; }
  return best;
}

/* ---------------------------------------------------- kits ARE their contents
   A kit is the physical panels it ships with plus its accessories - the same
   panels sold loose.  So a kit recommendation is an UPGRADE: when the planned
   wall already contains a kit's panels (anywhere - Wall Control panels mount
   independently), swap those purchases for the kit.  The geometry never
   changes; the packaging and the accessory count do. */

// physical panel class of a catalogue piece: a 2-pack is two 16x32 verticals
// sold as one purchase; everything else is one piece of its own size
function pieceClass(p){ return p.pack === 2 ? '16x32' : `${pieceW(p)}x${p.height}`; }
function pieceUnits(p){ return p.pack === 2 ? 2 : 1; }

// physical units present in a layout, per class, with what they cost as bought
function physUnits(placed){
  const pools = new Map();
  for(const pl of placed){
    if(pl.kit || pl.vmod) continue;
    const c = pieceClass(pl.panel);
    const pool = pools.get(c) || {units:0, cost:0};
    pool.units += pieceUnits(pl.panel);
    pool.cost  += pl.panel.price;
    pools.set(c, pool);
  }
  return pools;
}

// the panel multiset a kit supplies; null when any piece isn't the same
// physical panel as the loose catalogue one (slotted-only jewelry panel)
function kitNeeds(kit){
  const needs = new Map();
  for(const pp of (kit.panels || [])){
    if(pp.interchangeable === false) return null;
    const c = pp.w + 'x' + pp.h;
    needs.set(c, (needs.get(c) || 0) + pp.qty);
  }
  return needs.size ? needs : null;
}

function kitPanelsDesc(kit){
  return (kit.panels || []).map(pp =>
    `${pp.qty}× ${pp.w}&Prime;×${pp.h}&Prime;`).join(' + ');
}

// cheapest way to buy m physical units of a class from the enabled catalogue
function poolOptions(panels, cls){
  let single = null, pack = null;
  for(const p of panels){
    if(pieceClass(p) !== cls) continue;
    if(p.pack === 2){ if(!pack || p.price < pack.price) pack = p; }
    else if(!single || p.price < single.price) single = p;
  }
  return {single, pack};
}
function minPoolBuy(opts, m){
  if(m <= 0) return {cost:0, buy:[]};
  let best = null;
  for(let k = opts.pack ? Math.floor(m/2) : 0; k >= 0; k--){
    const rest = m - 2*k;
    if(rest > 0 && !opts.single) continue;
    const cost = (k ? k*opts.pack.price : 0) + (rest ? rest*opts.single.price : 0);
    if(!best || cost < best.cost)
      best = {cost, buy:[...(k ? [{panel:opts.pack, qty:k}] : []),
                        ...(rest ? [{panel:opts.single, qty:rest}] : [])]};
  }
  return best;                       // null: m units can't be bought exactly
}

/* The upgrade itself: null when the layout doesn't contain the kit's panels.
   delta = kit price + repricing the leftover units - what the pooled classes
   originally cost, so tierCost + delta reconciles exactly. */
function kitUpgrade(kit, placed, panels){
  const kv = kitVariant(kit);
  if(!kv) return null;
  const needs = kitNeeds(kit);
  if(!needs) return null;
  const pools = physUnits(placed);
  let delta = kv.price;
  const rebuys = [];
  for(const [cls, need] of needs){
    const pool = pools.get(cls);
    if(!pool || pool.units < need) return null;
    const re = minPoolBuy(poolOptions(panels, cls), pool.units - need);
    if(!re) return null;
    delta += re.cost - pool.cost;
    rebuys.push(...re.buy);
  }
  return {kv, delta, rebuys, needs};
}

/* Mark which drawn pieces the kit supplies - singles first so 2-packs are only
   claimed whole.  When the kit's count lands mid-pack the badge under-reports
   and `kitShort` says by how many panels. */
function badgeKit(placed, needs){
  const left = new Map(needs);
  const take = new Set();
  for(const round of [1, 2])
    placed.forEach((pl, i) => {
      if(pl.kit || pl.vmod || take.has(i)) return;
      const u = pieceUnits(pl.panel);
      if(u !== round) return;
      const c = pieceClass(pl.panel);
      if((left.get(c) || 0) >= u){ left.set(c, left.get(c) - u); take.add(i); }
    });
  const out = placed.map((pl, i) => take.has(i) ? {...pl, kit:true} : pl);
  out.kitShort = [...left.values()].reduce((a, b) => a + b, 0);
  return out;
}

/* Build a kit tier.  Automatic mode: the best kit upgrade of the given base
   fill — 'coverage' (max-coverage build) or 'value' (best-value build), so
   the tier row can offer both.  Picked mode: choose a fill whose layout
   contains the picked kit's panels; anchor the kit explicitly when none
   does. */
function planKitTier(panels, segs, H, vb, plan, extraCost=0, extraCov=0, fullArea=null, base='coverage'){
  if(!plan)
    return state.kitPick
      ? planKitAnchorSeg(panels, segs, H, vb, extraCost, extraCov, fullArea) : null;
  const tierOf = (f, up, kit) => {
    const cost = f.cost + up.delta + extraCost;
    if(!inBudget(cost)) return null;
    return {name: base === 'value' ? 'Best value + kit' : 'Max coverage + kit',
            sub: base === 'value' ? 'value layout, kit packaging'
                                  : 'coverage layout, kit packaging', kit,
            kitVariant:up.kv, kitUpgrade:true, height:f.height, cfg:f.cfg,
            delta:up.delta, rebuys:up.rebuys, needs:up.needs,
            cost, covered:f.covered + extraCov,
            pct: 100*(f.covered + extraCov)/(fullArea || 1),
            accessories: kit.accessories};
  };
  if(state.kitPick){
    const kit = D.kits.find(k => k.handle === state.kitPick);
    if(!kit || !kitOffered(kit) || !kitVariant(kit)) return null;
    const cands = [];
    for(const f of (plan.frontier || plan.pareto)){
      const up = kitUpgrade(kit, layoutPlan(plan, f.height, f.cfg), panels);
      if(!up) continue;
      const t = tierOf(f, up, kit);
      if(t) cands.push(t);
    }
    if(cands.length){
      cands.sort((a,b)=> b.covered - a.covered || a.cost - b.cost);
      return cands[0];
    }
    return planKitAnchorSeg(panels, segs, H, vb, extraCost, extraCov, fullArea);
  }
  const mo = base === 'value' ? byValue(plan) : byMaxCohesive(plan, extraCost);
  const placed = layoutPlan(plan, mo.height, mo.cfg);
  let best = null;
  const score = t => (t.accessories || 0) / Math.max(t.delta, 1);
  for(const kit of (state.face === 'slots' ? [] : D.kits.filter(kitOffered))){
    const up = kitUpgrade(kit, placed, panels);
    if(!up) continue;
    const t = tierOf(mo, up, kit);
    if(!t) continue;
    if(!best || score(t) > score(best) ||
       (score(t) === score(best) && t.delta < best.delta)) best = t;
  }
  return best;
}

/* A kit product can have independent pegboard and accessory finishes.  The
   extractor preserves every exact Shopify variant; recommendations resolve one
   variant in the selected wall colour, defaulting accessories to Black where
   available. */
function kitVariantsForColor(kit, color=state.color){
  return (kit.variants||[]).filter(v => v.pegboardColor === color);
}
function kitVariant(kit){
  const variants = kitVariantsForColor(kit);
  if(!variants.length) return null;
  const wanted = state.kitAccessory.get(kit.handle);
  return variants.find(v => v.accessoryColor === wanted)
      || variants.find(v => v.accessoryColor === 'Black')
      || variants[0];
}
function kitColor(kit){ return kitVariant(kit)?.pegboardColor || null; }
function kitAccessoryChoices(kit){
  return [...new Set(kitVariantsForColor(kit).map(v=>v.accessoryColor).filter(Boolean))]
    .sort((a,b)=>ACC_ORDER.indexOf(a)-ACC_ORDER.indexOf(b));
}
/* The customer's explicit accessory pick, or null.  A stale pick (made under a
   pegboard colour that offered it) doesn't count; kits with a single bundle
   have nothing to choose.  Pricing still falls back to Black via kitVariant()
   so an unchosen kit can be quoted, but Add to cart is gated on this. */
function kitAccessoryPicked(kit){
  const choices = kitAccessoryChoices(kit);
  if(choices.length < 2) return choices[0] || null;
  const acc = state.kitAccessory.get(kit.handle);
  return choices.includes(acc) ? acc : null;
}
function kitAccessoryChosen(kit){
  return kitAccessoryChoices(kit).length < 2 || !!kitAccessoryPicked(kit);
}
function finishNote(k, variant=kitVariant(k)){
  if(!variant) return `This kit isn't offered with ${state.color} pegboard.`;
  const choices = kitAccessoryChoices(k);
  if(choices.length > 1 && !kitAccessoryPicked(k))
    return `Pegboard finish: <strong>${variant.pegboardColor}</strong>. Accessories in your
      choice of ${choices.slice(0,-1).join(', ')} or ${choices[choices.length-1]}.`;
  return `Pegboard finish: <strong>${variant.pegboardColor}</strong>${variant.accessoryColor
    ? `. Accessory finish: <strong>${variant.accessoryColor}</strong>.` : '.'}`;
}

/* "Start from a kit" picker.  Kits that can't work right now stay listed but
   disabled, labelled with the reason, so the customer sees what would unlock
   them (a colour change, a bigger wall, a higher budget). */
function kitPickIssue(kit, W, H){
  if(!kitVariantsForColor(kit).length) return `not offered in ${state.color}`;
  if(kit.width > W || kit.height > H) return 'too big for this wall';
  if(state.budget.max != null && kitVariant(kit).price > state.budget.max)
    return 'over your max budget';
  return null;
}
function kitShortTitle(kit){ return kit.title.split(' - ')[0]; }
/* Kit browsing lives in a popup of product-style cards, grouped into a few
   customer-facing themes derived from the catalogue handles. */
function kitCategory(kit){
  const h = kit.handle;
  if(h.includes('laundry')) return 'Laundry';
  if(h.includes('kitchen') || h.includes('craft')) return 'Kitchen & Craft';
  if(h.includes('office') || h.includes('jewelry')) return 'Home & Office';
  if(h.includes('garden') || h.includes('lawn')) return 'Garden & Outdoor';
  return 'Garage & Workshop';
}
let kitCatFilter = 'All kits';
/* Kits deliberately excluded from EVERY kit surface - the browse popup, the
   kit-upgrade tier, the cross-sell box, and restored share links (owner
   requests, Aug 2026): the slotted-only jewelry organizer, the Premium Steel
   retail-box kit, the Patriot colourway, and the Ultimate kit (a relisting of
   the 4ft Premium kit, which stays offered and covers the same panels). They
   remain in D.kits only as data. */
const KIT_HIDE = new Set([
  'wall-organizer-great-for-jewelry-or-tool-wall-storage-wall-mounted-orange-slotted-only-organizer-panel-with-hooks',
  'metal-pegboard-utility-tool-storage-kit-black-pegboard-with-hooks',
  '4ft-patriot-pegboard-standard-tool-storage-kit-red-white-blue',
  'ultimate-metal-pegboard-wall-organizer-kit'
]);
function kitOffered(k){ return !KIT_HIDE.has(k.handle); }
/* Kits featured in the inline strip on the planner page, in display order. */
const KIT_STRIP = [
  '4ft-metal-pegboard-standard-tool-storage-kit-toolboard-with-hooks',  // 4ft Metal Pegboard Premium Tool Storage Kit
  '8ft-metal-pegboard-master-workbench-kit-blue-toolboard-white-accessories',  // Master Workbench Kit
  'craft-hobby-pegboard-organizer-kit-pegboard-with-accessories',        // Craft & Hobby Kit
  'kitchen-pegboard-organizer-kit-pots-pans-rack-pegboard-with-hooks',   // Kitchen Kit
];
function drawKitDlg(W, H){
  const browsable = D.kits.filter(kitOffered);
  const cats = ['All kits', ...new Set(browsable.map(kitCategory))];
  if(!cats.includes(kitCatFilter)) kitCatFilter = 'All kits';
  document.getElementById('kitCats').innerHTML = cats.map(c =>
    `<button type="button" class="kitcat" data-cat="${c}"
       aria-pressed="${c===kitCatFilter}">${c}</button>`).join('');
  document.querySelectorAll('#kitCats .kitcat').forEach(b => b.onclick = () => {
    kitCatFilter = b.dataset.cat; drawKitDlg(W, H);
  });
  const list = browsable.filter(k =>
    kitCatFilter === 'All kits' || kitCategory(k) === kitCatFilter);
  const card = k => {
    const issue = kitPickIssue(k, W, H), kv = kitVariant(k);
    const sel = k.handle === state.kitPick;
    return `<button type="button" class="kitcard${sel?' sel':''}" data-kit="${k.handle}"
        ${issue && !sel ? 'disabled' : ''} title="${kitShortTitle(k)}">
      ${k.image ? `<img src="${k.image}" alt="" loading="lazy">` : `<span class="kitimg"></span>`}
      <b>${kitShortTitle(k)}</b>
      <span class="kitmeta">${kitPanelsDesc(k) || `${k.width}&Prime;×${k.height}&Prime;`}${
        k.accessories!=null ? ` · ${k.accessories} accessories` : ''}</span>
      <span class="kitmeta${issue?'':' kitprice'}">${issue ? issue : (kv ? money(kv.price) : '')}</span>
    </button>`;
  };
  document.getElementById('kitCards').innerHTML =
    `<button type="button" class="kitcard nokit${state.kitPick ? '' : ' sel'}" data-kit="">
       <b>No kit</b>
       <span class="kitmeta">Recommend automatically from the whole catalogue.</span>
     </button>` + list.map(card).join('');
  document.querySelectorAll('#kitCards .kitcard').forEach(b => b.onclick = () => {
    state.kitPick = b.dataset.kit || null;
    state.tier = 0; state.pick = null;
    document.getElementById('kitDlg').close();
    render();
  });
}
function drawKitPick(W, H){
  if(state.kitPick && (KIT_HIDE.has(state.kitPick)
      || !D.kits.some(k => k.handle === state.kitPick)))
    state.kitPick = null;
  const pk = state.kitPick ? D.kits.find(k => k.handle === state.kitPick) : null;
  const view = document.getElementById('kitPickView');
  const kv = pk ? kitVariant(pk) : null;
  view.innerHTML = pk ? `
    <div class="kitpicked">
      ${pk.image ? `<img src="${pk.image}" alt="">` : ''}
      <div>
        <b>${kitShortTitle(pk)}</b>
        <span class="kitmeta">${kitPanelsDesc(pk) || `${pk.width}&Prime;×${pk.height}&Prime;`}${
          kv ? ' · '+money(kv.price) : ''}</span>
      </div>
      <button type="button" class="reset" id="kitClear">Clear</button>
    </div>` : '';
  if(pk) document.getElementById('kitClear').onclick = ()=>{
    state.kitPick = null; state.tier = 0; state.pick = null; render();
  };
  // Inline strip: the curated KIT_STRIP kits lead, in merchandising order,
  // so the visual does the selling before anyone opens the full catalogue.
  // A featured kit that can't be used on this wall (wrong colour, too big,
  // over budget) gives its slot to the cheapest other usable kit, so the
  // strip always shows something buyable; only when nothing at all fits do
  // the featured kits show disabled with the reason. Hidden once a kit is
  // chosen (the picked card takes its place) and in slotted mode (kits ship
  // Slots & Dots panels).
  const strip = document.getElementById('kitStrip');
  const STRIP_N = KIT_STRIP.length;
  const curated = KIT_STRIP.map(h => D.kits.find(k => k.handle === h)).filter(k => k && kitOffered(k));
  const usable = k => !!kitVariant(k) && !kitPickIssue(k, W, H);
  let featured = [];
  if(!pk && state.face !== 'slots'){
    featured = curated.filter(usable);
    if(featured.length < STRIP_N)
      featured = featured.concat(D.kits
        .filter(k => kitOffered(k) && usable(k) && !featured.includes(k))
        .sort((a,b) => kitVariant(a).price - kitVariant(b).price)
        .slice(0, STRIP_N - featured.length));
    if(!featured.length) featured = curated;
  }
  strip.innerHTML = featured.map(k => {
    const issue = kitPickIssue(k, W, H);
    return `
    <button type="button" class="kitcard" data-kit="${k.handle}" title="${kitShortTitle(k)}"
        ${issue ? 'disabled' : ''}>
      ${k.image ? `<img src="${k.image}" alt="" loading="lazy">` : `<span class="kitimg"></span>`}
      <b>${kitShortTitle(k)}</b>
      <span class="kitmeta">${kitPanelsDesc(k) || `${k.width}&Prime;×${k.height}&Prime;`}</span>
      <span class="kitmeta${issue?'':' kitprice'}">${issue || money(kitVariant(k).price)}</span>
    </button>`; }).join('');
  strip.querySelectorAll('.kitcard').forEach(b => b.onclick = () => {
    state.kitPick = b.dataset.kit; state.tier = 0; state.pick = null; render();
  });
  const btn = document.getElementById('kitPickBtn');
  btn.textContent = pk ? 'Change kit' : 'See all kits';
  btn.disabled = state.face === 'slots';
  btn.onclick = () => {
    drawKitDlg(W, H);
    document.getElementById('kitDlg').showModal();
  };
  document.getElementById('kitPickNote').textContent = state.face === 'slots'
    ? 'Kits ship Slots & Dots panels — switch the face type to start from one.'
    : (state.kitPick ? '' : 'Pick a kit and the planner will build the wall around it.');
}

function layoutKit(T){
  const placed = [];
  const kc = T.kit.width/COL;
  const kc_color = T.kitVariant.pegboardColor;
  const kx = T.kitX || 0;         // segment offset when V columns split the wall
  // The kit's own pieces: verticals side by side along the bottom, runner
  // strips as full-width rows.  Pieces beyond the footprint (the laundry and
  // garden kits' bonus runners) aren't part of the anchored rectangle.
  const pieces = [];
  for(const pp of (T.kit.panels || []))
    for(let i=0;i<pp.qty;i++) pieces.push(pp);
  if(pieces.length){
    let x=0, y=0, rowH=0;
    for(const pc of pieces){
      if(x + pc.w > T.kit.width){ x=0; y+=rowH; rowH=0; }
      if(y + pc.h > T.kit.height) continue;    // bonus piece beyond footprint
      placed.push({kit:true, panel:{color:kc_color, height:pc.h, pack:1},
                   x:kx + x, y, w:pc.w, h:pc.h});
      x += pc.w; rowH = Math.max(rowH, pc.h);
    }
  } else {
    for(let i=0;i<kc;i++)
      placed.push({kit:true, panel:{color:kc_color, height:T.kit.height, pack:1},
                   x:kx + i*COL, y:0, w:COL, h:T.kit.height});
  }
  if(T.above)
    for(const p of layout(T.above.region, T.above.t))
      placed.push({...p, x:p.x + kx, y:p.y + T.kit.height});
  if(T.beside)
    for(const p of layout(T.beside.region, T.beside.t))
      placed.push({...p, x:p.x + kx + T.kit.width});
  if(T.oFills)
    for(const f of T.oFills)
      for(const p of layout(f.region, f.t))
        placed.push({...p, x:p.x + f.x0*COL});
  return placed;
}

/* ---------------------------------------------------------- 3D V-Bracket module
   ASM-3DVB bracket kit + two 16in-wide panels of the chosen height, forming a V
   that projects 15-1/16in from the wall while occupying ONE 16in column of the
   layout (VBR-1616 assembly drawing).  Explicit opt-in: it never competes with
   the optimiser, it reserves the right-hand column and the solver fills the rest
   - including the leftover strip above the module in its own column. */
function vbHeights(inColour, wallH=Infinity){
  if(!D.vbracket) return [];
  return Object.keys(D.vbracket.heights).map(Number).sort((a,b)=>b-a)
    .filter(h => h <= wallH && inColour.some(p => pieceW(p)===COL && p.height===h));
}
function vbPanelChoice(inColour, h){
  // the V needs two 16in-wide panels of height h: a 2-pack IS the pair,
  // otherwise two singles - whichever costs less
  let best=null;
  for(const p of inColour){
    if(pieceW(p)!==COL || p.height!==h) continue;
    const qty = p.pack>1 ? 1 : 2;
    const cost = p.price*qty;
    if(!best || cost < best.cost) best = {p, qty, cost};
  }
  return best;
}
/* Column picks for n modules: 1 sits in the middle, 2 take the outside edges,
   3 is middle and both edges - in general the n modules spread evenly across
   the width with the edges always included once n > 1. */
function vbColumns(n, totCols){
  if(n >= totCols) return [...Array(totCols).keys()];
  if(n === 1) return [Math.floor((totCols-1)/2)];
  const pos = new Set();
  for(let i=0;i<n;i++) pos.add(Math.round(i*(totCols-1)/(n-1)));
  let c = 0;                       // tiny walls: fill nearest free on collision
  while(pos.size < n && c < totCols){ pos.add(c); c++; }
  return [...pos].sort((a,b)=>a-b);
}
function vbSegments(vb, totCols){
  // the free contiguous column runs left over between reserved V columns
  if(!vb) return totCols >= 1 ? [{x0:0, cols:totCols}] : [];
  const segs=[]; let prev=0;
  for(const c of vb.cols){
    if(c > prev) segs.push({x0:prev, cols:c-prev});
    prev = c+1;
  }
  if(totCols > prev) segs.push({x0:prev, cols:totCols-prev});
  return segs;
}
function buildVB(inColour, totCols, H){
  if(!state.vb.on || !D.vbracket) return null;
  const hs = vbHeights(inColour, H);
  if(!hs.length || totCols < 1) return null;
  const h = hs.includes(state.vb.h) ? state.vb.h : hs[0];
  if(H < h) return null;
  const variants = D.vbracket.heights[h];
  const n = Math.max(1, Math.min(state.vb.n||1, totCols));
  const colr = state.vb.color && variants[state.vb.color] ? state.vb.color
             : (variants[state.color] ? state.color : 'Black');
  const bk = variants[colr];
  const pc = vbPanelChoice(inColour, h);
  if(!bk || !pc) return null;
  return {h, n, color:colr, bracket:bk, panel:pc,
          cols: vbColumns(n, totCols),
          matched: colr === state.color,
          cost: n*(bk.price + pc.cost),
          covered: n*COL*h};
}
const VB_COLORS = ['Black','White','Red','Blue'];   // the ASM kit's finish range
function drawVB(inColour, H){
  const box = document.getElementById('vbBox'), note = document.getElementById('vbNote');
  if(!D.vbracket){ box.innerHTML=''; note.textContent='Not in the catalogue export.'; return; }
  const hs = vbHeights(inColour, H);
  const h = hs.includes(state.vb.h) ? state.vb.h : hs[0];
  const pc = hs.length ? vbPanelChoice(inColour, h) : null;
  const bkv = hs.length ? D.vbracket.heights[h] : null;
  const eff = state.vb.color && bkv && bkv[state.vb.color] ? state.vb.color
            : (bkv && bkv[state.color] ? state.color : 'Black');
  const bk = bkv ? bkv[eff] : null;
  const n = state.vb.n || 1;
  const each = bk ? bk.price + (pc?pc.cost:0) : 0;
  box.innerHTML = `
    <label class="tog"><input type="checkbox" id="vbOn"
        ${state.vb.on?'checked':''} ${hs.length?'':'disabled'}>
      <span>Add V-Bracket columns</span>
      ${bk?`<b>${money(each*(state.vb.on?n:1))}</b>`:''}</label>
    ${state.vb.on && hs.length ? `
    <div style="display:flex;align-items:center;gap:12px;margin-top:10px">
      <button class="qty" data-vbn="-1" ${n<=1?'disabled':''}>&minus;</button>
      <b style="font-variant-numeric:tabular-nums">${n}</b>
      <button class="qty" data-vbn="1">+</button>
      <span style="font-size:12.5px;color:var(--muted)">${n===1?'one column, centred':
        n===2?'both outside edges':'edges + spread between'}</span>
    </div>
    ${hs.length>1 ? `<div style="display:flex;gap:6px;margin-top:10px">
      ${hs.map(x=>`<button class="tier" style="flex:1;min-width:0;padding:8px 6px;text-align:center"
        data-vh="${x}" aria-pressed="${x===h}"><b>${x}&Prime; panels</b></button>`).join('')}
    </div>`:''}
    <div style="margin-top:12px">
      <span style="font-size:11px;color:var(--muted);text-transform:uppercase;letter-spacing:.6px">
        Bracket kit color: <b style="color:var(--ink)">${eff}</b></span>
      <div class="swatches" style="margin-top:7px">
        ${VB_COLORS.map(c=>`<button class="sw" data-vbc="${c}" title="${c}" aria-label="${c}"
          aria-pressed="${c===eff}"><i style="background:${HEX[c]}"></i></button>`).join('')}
      </div>
    </div>`:''}`;
  note.innerHTML = !hs.length
    ? `Needs an enabled 16&Prime;-wide panel size no taller than your ${H}&Prime; wall.`
    : `Two ${h}&Prime; panels angled into a V per column &mdash; deep storage for long-handle
       tools without giving up the footprint. Panels come in your wall color;
       the bracket kit in ${eff}.`;
  const cb = document.getElementById('vbOn');
  if(cb) cb.onchange = ()=>{ state.vb.on = cb.checked; state.tier = 0; render(); };
  document.querySelectorAll('[data-vh]').forEach(b=>b.onclick=()=>{
    state.vb.h = +b.dataset.vh; render(); });
  document.querySelectorAll('[data-vbn]').forEach(b=>b.onclick=()=>{
    const tot = Math.floor(inches()[0]/COL);
    state.vb.n = Math.max(1, Math.min((state.vb.n||1) + (+b.dataset.vbn), tot));
    render(); });
  document.querySelectorAll('[data-vbc]').forEach(b=>b.onclick=()=>{
    state.vb.color = b.dataset.vbc; render(); });
}

/* ------------------------------------------------------------------- render */
function money(n){ return '$'+(n/100).toFixed(2); }   // all prices are integer cents
/* Dimensions are applied explicitly (the first-run dialog or the Update
   layout button), never on keystroke — the solver only ever sees a committed
   size. Beyond the supported plan area the planner refuses and points at
   the contact page: the DP walks every inch of height and the renderer draws
   every real hole, so a 100ft entry would freeze the tab. */
const MAX_W = 480, MAX_H = 240;   // 40ft × 20ft supported plan area
const BULK_MSG = `Walls wider than ${MAX_W/12}ft or taller than ${MAX_H/12}ft are beyond
  what the planner can lay out. <a href="/pages/contact-wall-control">Contact us</a>
  for additional support with planning a wall.`;
function inches(){
  return state.dims ? [state.dims.w, state.dims.h] : [0, 0];
}
function dimsFrom(ids){
  const g = id => Math.max(0, parseInt(document.getElementById(id).value||0, 10));
  return {w: g(ids[0])*12 + g(ids[1]), h: g(ids[2])*12 + g(ids[3])};
}
function tryApplyDims(d, noteEl){
  if(d.w > MAX_W || d.h > MAX_H){
    // refuse without touching the committed plan, so backing out loses nothing
    noteEl.innerHTML = BULK_MSG;
    return false;
  }
  state.dims = d; state.tier = 0; state.pick = null; render();
  window.wallZoom?.reset();   // a new wall starts at 1x
  return true;
}

function render(){
  const [W,H] = inches();
  const inFace = D.panels.filter(p => !!p.slotted === (state.face === 'slots'));
  const inColour = inFace.filter(p=>p.color===state.color);
  // one switch per SIZE - packs share their single's key and ride along with it
  const panels = inColour.filter(p=>!state.off.has(sizeKey(p)));
  const box = document.getElementById('kitBox');

  document.getElementById('dimNote').textContent =
    W&&H ? `${Math.floor(W/12)}′ ${W%12}″ × ${Math.floor(H/12)}′ ${H%12}″ — ${(W*H/144).toFixed(1)} sq ft`
    : 'No wall size set yet.';
  const nSizes = new Set(inColour.map(sizeKey)).size;
  document.getElementById('colorNote').textContent =
    `${nSizes} panel size${nSizes===1?'':'s'} available in ${state.color}.`;
  document.querySelectorAll('#facePick button').forEach(b =>
    b.setAttribute('aria-pressed', b.dataset.face === state.face));
  updateSwatches();
  drawToggles(inColour);
  drawVB(panels, H);
  if(KITS_ON) drawKitPick(W, H);
  // what's active inside the closed "More options" fold, so nothing can
  // quietly shape the layout from out of sight
  const nOff = new Set(inColour.map(sizeKey).filter(k => state.off.has(k))).size;
  document.getElementById('moreBadge').textContent = [
    nOff ? `${nOff} panel size${nOff===1?'':'s'} excluded` : '',
    state.vb.on ? `${state.vb.n||1} V-Bracket${(state.vb.n||1)===1?'':'s'}` : ''
  ].filter(Boolean).join(' · ');
  const {min,max} = state.budget;
  document.getElementById('budgetNote').textContent =
    max!=null || min!=null
      ? `${min!=null?`From ${money(min)}`:'Up'}${min!=null&&max!=null?' up':''}${max!=null?` to ${money(max)}`:''}`
      : 'No limit';
  document.getElementById('editBudget').textContent = max!=null || min!=null ? 'Change' : 'Set';

  const fail = msg => {
    // nothing is buyable: drop the stale tiers so Add to cart / payload()
    // can't emit the previous plan, and say so on the button
    state.tiers = []; state._vb = null;
    document.getElementById('addAll').disabled = true;
    document.getElementById('tiers').innerHTML='';
    document.getElementById('combos').innerHTML='';
    document.getElementById('stats').innerHTML = `<p class="note">${msg}</p>`;
    document.getElementById('svg').innerHTML=''; box.innerHTML='';
    document.getElementById('lines').innerHTML='';
    document.getElementById('caveats').textContent='';
  };

  // sharing needs a wall; the rail sits beside the diagram on desktop, so
  // point at the Size row rather than "above"
  document.getElementById('sharePlan').disabled = !state.dims;
  if(!state.dims) return fail('Enter your wall size (the Size row of Your wall) to see a plan.');
  if(!panels.length) return fail('No sizes selected — switch at least one back on.');
  if(W < COL || H < 8)
    return fail('A wall needs to be at least 16&Prime; wide and 8&Prime; tall to take a panel.');

  // V-Bracket modules reserve their columns; the solver fills the segments
  // left between them (one centred, two at the edges, more spread evenly)
  const totCols = Math.floor(W/COL);
  const vb = buildVB(panels, totCols, H);
  state._vb = vb;
  const vbC = vb ? vb.cost : 0, vbCov = vb ? vb.covered : 0;
  const segs = vbSegments(vb, totCols);

  const raw = (segs.length || vb) ? solveSplit(panels, segs, H, vb) : null;
  if(!raw && !vb){
    // solvable geometry, just not with the sizes left switched on
    const narrow = panels.some(p=>p.cols===1);
    const shortest = Math.min(...panels.map(p=>p.height));
    return fail(!narrow && totCols % 2
      ? `Your wall is ${totCols} columns of 16&Prime; wide — an odd number — and only
         32&Prime;-wide panels are switched on, which fill two columns at a time. Switch on a
         16&Prime;-wide size to finish the last column.`
      : `The sizes left on can't fill a wall this shape — the shortest is ${shortest}&Prime; tall
         and your wall is ${H}&Prime;. Try switching more sizes back on.`);
  }

  // apply the budget to the frontier before any tier is chosen (V cost included)
  const plan = raw ? {...raw, pareto: raw.pareto.filter(f=>inBudget(f.cost + vbC))} : null;
  if(raw && !plan.pareto.length){
    const cheapest = raw.pareto[0].cost + vbC,
          dearest  = raw.pareto[raw.pareto.length-1].cost + vbC;
    return fail(state.budget.max!=null && cheapest > state.budget.max
      ? `Nothing fits under ${money(state.budget.max)} — the smallest layout for this
         wall is ${money(cheapest)}.`
      : `No layout falls in that range. Options here run
         ${money(cheapest)}–${money(dearest)}.`);
  }

  const area = W*H;
  const pt = (name,sub,f)=>({name, sub, ...f, cost:f.cost+vbC, covered:f.covered+vbCov,
                             pct:100*(f.covered+vbCov)/area, panelsOnly:true});
  const tiers = plan ? [
    pt('Best value',   'lowest cost per sq ft', byValue(plan)),
    pt('Max coverage', 'panels only',           byMaxCohesive(plan, vbC)),
  ].filter((t,i,a)=> i===0 || t.height!==a[i-1].height)    // drop duplicates
  : [{name: (vb&&vb.n>1?vb.n+'× ':'')+'3D V-Bracket', sub: vb&&vb.n>1?'every column':'single column',
      cost:vbC, covered:vbCov, pct:100*vbCov/area, height:0, vbOnly:true}];
  if(!plan && !inBudget(vbC))
    return fail(`The V-Bracket build comes to ${money(vbC)}, outside your budget range.`);

  if(!KITS_ON){
    state.kitPick = null;   // kits are switched off: no kit tiers, and a restored link's kit is dropped
  } else if(state.kitPick){
    const kitPlan = planKitTier(panels, segs, H, vb, plan, vbC, vbCov, area);
    if(kitPlan){
      // an explicitly chosen kit leads: it becomes the first tier, not a runner-up
      kitPlan.name = 'Your kit'; kitPlan.sub = '+ panels around it';
      tiers.unshift(kitPlan);
    }
    const pk = D.kits.find(k => k.handle === state.kitPick);
    document.getElementById('kitPickNote').textContent = kitPlan
      ? `Layouts are built around the ${kitShortTitle(pk)}.`
      : `The ${kitShortTitle(pk)} can't anchor this wall — ${kitPickIssue(pk, W, H)
         || "it doesn't fit the wall space left free"}. Showing panel-only layouts.`;
  } else {
    // two kit tiers, one per base fill; identical outcomes collapse into one
    const kitValue = planKitTier(panels, segs, H, vb, plan, vbC, vbCov, area, 'value');
    const kitCover = planKitTier(panels, segs, H, vb, plan, vbC, vbCov, area, 'coverage');
    if(kitValue) tiers.push(kitValue);
    if(kitCover && !(kitValue && kitCover.kit === kitValue.kit
        && kitCover.height === kitValue.height && kitCover.cost === kitValue.cost))
      tiers.push(kitCover);
  }

  /* A row picked out of the full combination list becomes an extra tier, added
     last so the headline picks keep their indices.  It's dropped if the wall
     or the switches changed such that its fill height no longer exists. */
  if(state.pick != null && plan){
    const f = plan.pareto.find(x => x.height === state.pick);
    const already = tiers.findIndex(t => !t.kit && t.height === state.pick);
    if(!f) state.pick = null;
    else if(already >= 0) state.tier = already;
    else { tiers.push(pt('Your pick','from all combinations', f)); state.tier = tiers.length-1; }
  }

  state.tiers = tiers;
  if(state.tier >= tiers.length) state.tier = tiers.length-1;
  if(state._tierName){   // a restored link names its tier; the index is only a fallback
    const i = tiers.findIndex(t => t.name === state._tierName);
    if(i >= 0) state.tier = i;
    state._tierName = null;
  }
  document.getElementById('addAll').disabled = false;
  syncPlanHash();
  const T = tiers[state.tier];

  document.getElementById('tiers').innerHTML = tiers.map((t,i)=>`
    <button class="tier" aria-pressed="${i===state.tier}" data-i="${i}">
      <span class="tname"><b>${t.name}</b><em>${t.sub||''}</em></span>
      <span class="tnum"><b>${money(t.cost)}</b><em>${t.pct.toFixed(0)}% covered${
        t.accessories ? ` · ${t.accessories} accessories` : ''}</em></span>
    </button>`).join('');
  document.querySelectorAll('#tiers .tier').forEach(b=>b.onclick=()=>{
    const i = +b.dataset.i;
    if(tiers[i].name !== 'Your pick') state.pick = null;   // headline tier wins
    state.tier = i; render();
  });
  if(plan) drawCombos(plan, area, tiers, vbC, vbCov);
  else document.getElementById('combos').innerHTML='';

  const sqft = T.covered/144;
  const accStat = T.kit
    ? `<div class="stat"><div class="k">Accessories</div><div class="v">${
        T.accessories==null ? '—' : T.accessories}</div></div>` : '';
  document.getElementById('stats').innerHTML = `
    <div class="stat"><div class="k">Subtotal</div><div class="v">${money(T.cost)}</div></div>
    <div class="stat"><div class="k">Coverage</div><div class="v">${T.pct.toFixed(0)}%</div></div>
    <div class="stat"><div class="k">Pegboard</div><div class="v">${sqft.toFixed(1)} sq ft</div></div>
    <div class="stat"><div class="k">Per sq ft</div><div class="v">${money(T.cost/sqft)}</div></div>
    ${accStat}`;

  const placed = T.vbOnly ? []
               : T.kitUpgrade ? badgeKit(layoutPlan(plan, T.height, T.cfg), T.needs)
               : (T.kit && T.kitAnchor) ? layoutKit(T)
               : layoutPlan(plan, T.height, T.cfg);
  if(vb)
    vb.cols.forEach(c =>
      placed.push({vmod:true, bracket:vb.color,
                   panel:{color:state.color, height:vb.h, pack:1},
                   x:c*COL, y:0, w:COL, h:vb.h}));
  drawWall(W,H,placed);
  drawLines(placed, T);
  // with an explicit kit choice there is nothing to cross-sell - the chosen
  // kit already has its own tier
  if(T.kit) showKitContents(T, box);
  else if(plan && KITS_ON && !state.kitPick) suggestKit(T, W, H, box);
  else box.innerHTML='';

  const usedW = (plan ? plan.cols*COL : 0) + (vb ? vb.n*COL : 0);
  const bareW = W - usedW;
  document.getElementById('caveats').innerHTML =
    (T.kitUpgrade
      ? `The ${T.kit.title} ships ${kitPanelsDesc(T.kit)} panels — the same panels this
         layout uses — so buying the kit replaces those loose-panel purchases outright,
         and its accessories work anywhere on the wall.` +
        (placed.kitShort ? ` ${placed.kitShort} of its panels stand in for part of a
         2-pack, so the outline marks fewer pieces than the kit supplies.` : '')
      : T.kit
      ? `The ${T.kit.title} anchors the bottom ${T.kit.height}" and loose panels fill the rest.`
      : T.vbOnly
      ? `The V-Bracket assembl${vb.n>1?'ies fill':'y fills'} your ${W}" wall.`
      : '') +
    (bareW > 0 ? ` ${bareW}" of width is left bare — panels only come in 16" increments.` : '');
}

/* --------------------------------------------------------- all combinations
   The three headline tiers are three points on the same cost/coverage frontier
   the solver already built.  This lists the rest of it, so someone who wants
   "a bit more wall than Best value but not the full price of Max coverage" can
   see and take that trade directly.  Folded away by default: three named picks
   is the decision most people want to make.  Kit-anchored builds aren't on this
   frontier (they're a different shape of layout), so they stay out of the list. */
function drawCombos(plan, area, tiers, vbC=0, vbCov=0){
  const el = document.getElementById('combos');
  const named = new Map();
  tiers.forEach(t => { if(!t.kit && t.name !== 'Your pick') named.set(t.height, t.name); });
  const active = tiers[state.tier];
  const rows = plan.pareto.slice().sort((a,b)=> a.cost-b.cost);

  if(rows.length < 2){
    el.innerHTML = `<p class="combos-note">This is the only combination for this wall.</p>`;
    return;
  }

  const body = rows.map(f=>{
    const mix = tally(layoutPlan(plan, f.height, f.cfg))
      .map(({p,n}) => `${n}&times; ${p.height}&Prime;&hairsp;&times;&hairsp;${pieceW(p)}&Prime;`)
      .join(' &nbsp;+&nbsp; ');
    const on = !active.kit && active.height === f.height;
    const cc = f.cost + vbC, cv = f.covered + vbCov;
    return `<button class="combo" data-h="${f.height}" aria-pressed="${on}">
        <span>${money(cc)}</span>
        <span>${(100*cv/area).toFixed(0)}% covered</span>
        <span>${f.height}&Prime; tall</span>
        <span>${money(cc/(cv/144))}/sq ft</span>
        <span class="mix">${mix}${named.has(f.height)
          ? ` <span class="tag">${named.get(f.height)}</span>` : ''}</span>
      </button>`;
  }).join('');

  el.innerHTML = `<details class="combos"${state.combosOpen?' open':''}>
      <summary>Show all ${rows.length} combinations for this wall</summary>
      <div class="combolist">
        <div class="combohead"><span>Price</span><span>Coverage</span><span>Fill height</span>
          <span>Per sq ft</span><span>Panels</span></div>
        ${body}
      </div>
      <p class="note" style="margin:8px 0 0">Every layout that isn't beaten on both price and
        coverage by another. Kit-anchored builds aren't listed here &mdash; pick the kit tier
        above for those.</p>
    </details>`;
  el.querySelector('details').ontoggle = e => { state.combosOpen = e.target.open; };
  el.querySelectorAll('.combo').forEach(b => b.onclick = () => {
    state.pick = +b.dataset.h; render();
  });
}

/* Panel face geometry, taken from the Wall Control shop drawings (30HP1632_2D,
   30P3216).  Peg holes are DIA .250" on a 1in grid.  Slots are 1.000" x .094",
   on a 1in horizontal pitch but only every other row - so a slot row reads
   slot / hole / slot.  The repeating tile is therefore 1in wide x 2in tall.
   `S` is px per inch, so one definition serves both the wall diagram and the
   zoomed detail swatch. */
const HOLE_DIA = 0.250, SLOT_L = 1.000, SLOT_W = 0.094;
const ACCESS_DIA = 0.530;      // mounting / access hole, "TYP 6 PLCS"

/* Panel faces are TRACED from the shop drawings (see export_faces.py) rather
   than approximated with a repeating tile.  Each entry gives the real peg /
   slot / mounting-hole lattice in panel-local inches, so nothing tiles across a
   seam and nothing gets clipped at a panel edge.  The horizontal and vertical
   panels genuinely differ: on the 16x32 the slots sit level with the peg rows,
   on the 32x16 they sit halfway between them. */
const FACES = window.PANEL_FACES;

function faceKey(w, h){ return FACES[w + 'x' + h] ? w + 'x' + h : null; }

/* One <g> per (panel size, ink) pair, referenced by <use> for each instance.

   `pxPerUser` is how many screen pixels one SVG user unit occupies.  A .094in
   slot works out around 1.5px on a typical wall, and at that size how much ink
   lands in each pixel depends on where the column happens to fall on the pixel
   grid - some columns come out up to 50% brighter than their neighbours, which
   reads as pale vertical banding.  So features get a floor of ~1.8px on screen.
   Geometry stays exact whenever the panel is drawn big enough for it to matter. */
const MIN_FEATURE_PX = 1.8;

/* slotted: the slotted-only line's face is the same traced lattice minus the
   peg holes (owner call, Aug 2026 - reuse the trace rather than re-derive). */
function faceGroup(key, S, inkRGB, inkA, rim, pxPerUser, slotted){
  const f = FACES[key];
  const floor = MIN_FEATURE_PX / (pxPerUser || 1);
  const trueSw = SLOT_W*S, trueR = (HOLE_DIA/2)*S;
  const sw = Math.max(trueSw, floor);
  const r  = Math.max(trueR, floor/2);
  // Widening keeps features off the aliasing threshold, but drawn at full
  // strength it would make a big wall look far more perforated than it is.
  // Fade the ink by the same factor so the field keeps its true density.
  const widen = sw / trueSw;
  // fade with the square root of the widening rather than linearly: the
  // slots-and-dots field is the product's signature, so it should stay clearly
  // visible on big walls instead of dissolving into faint grain
  const ink = `rgba(${inkRGB},${Math.max(inkA/Math.sqrt(widen), 0.22).toFixed(3)})`;
  const sl = SLOT_L*S, ar = Math.max((ACCESS_DIA/2)*S, floor/2);
  const n = v => v.toFixed(2);
  let g = '';
  if(!slotted)
    for(const x of f.pegs.xs) for(const y of f.pegs.ys)
      g += `<circle cx="${n(x*S)}" cy="${n(y*S)}" r="${n(r)}" fill="${ink}"/>`;
  for(const x of f.slots.xs) for(const y of f.slots.ys)
    g += `<rect x="${n(x*S-sw/2)}" y="${n(y*S-sl/2)}" width="${n(sw)}"
            height="${n(sl)}" rx="${n(sw/2)}" fill="${ink}"/>`;
  for(const [x, y] of f.screws)
    g += `<circle cx="${n(x*S)}" cy="${n(y*S)}" r="${n(ar)}" fill="${rim}"/>`;
  return g;
}

/* Grey out (never hide) swatches whose colourway isn't offered in the selected
   face type, so switching faces causes no layout shift. */
function updateSwatches(){
  const avail = new Set(D.panels
    .filter(p => !!p.slotted === (state.face === 'slots')).map(p => p.color));
  document.querySelectorAll('.sw').forEach(b => {
    const ok = avail.has(b.dataset.c);
    b.classList.toggle('na', !ok);
    b.setAttribute('aria-disabled', !ok);
    b.title = ok ? b.dataset.c
      : `${b.dataset.c} \u2014 not offered in ${state.face === 'slots' ? 'Slotted Only' : 'Slots & Dots'}`;
  });
}

function drawWall(W,H,placed){
  const PAD=26, S=Math.min(820/W, 420/H, 6);
  const w=W*S, h=H*S;
  // measure the container before we replace the old <svg>, so faceGroup knows
  // how big a user unit actually is on screen. The svg sits in a fixed-height
  // viewport and scales to fit (preserveAspectRatio meet), so the real scale
  // is set by whichever axis is tighter — width for tall walls, height for
  // wide ones. Using width alone under-sizes the feature floor on wide walls
  // and the sub-pixel holes alias into pale speckles.
  // #svgWrap, not the svg: the zoom transform on #svgZoom scales the svg's
  // client rect, and the feature floor must be sized for the 1x view.
  const prev = document.getElementById('svgWrap');
  const box = prev && prev.getBoundingClientRect();
  const cssW = (box && box.width) || 640, cssH = (box && box.height) || 0;
  const pxPerUser = Math.min(cssW / (w + PAD*2),
                             cssH ? cssH / (h + PAD*2) : Infinity);
  const LIGHT=['White','Ghost White','Beige','Metallic','Desert Sand','Yellow','Gold'];
  /* Pattern ink: white only on the black-family finishes, black on every other
     colour - and strong enough to read as the product's signature perforation. */
  const BLACKISH=['Black','Stealth Black','Gun Metal Grey'];
  let defs='', body='', kitBox=null;
  /* Panels are painted in three passes - every fill, then every face and
     label, then every outline - and each fill bleeds a little past its own
     edge so neighbours overlap under the seam.  Butted rects leave a
     conflation gap: each covers half of the shared pixel and the wall shows
     through the rest, and a translucent stroke over that gap is lighter
     still.  On 1.25x / 1.5x displays it read as a pale line between every
     panel.  Now the outline is always a dark line over panel colour. */
  let fills='', edges='';
  const BLEED = 0.4;
  const panelFill = (x, y, pw, ph, c) =>
    `<rect x="${(x-BLEED).toFixed(2)}" y="${(y-BLEED).toFixed(2)}" width="${(pw+2*BLEED).toFixed(2)}"
        height="${(ph+2*BLEED).toFixed(2)}" fill="${c}"/>`;
  const panelEdge = (x, y, pw, ph, blackish) =>
    `<rect x="${x+.5}" y="${y+.5}" width="${pw-1}" height="${ph-1}" fill="none"
        stroke="${blackish ? '#000' : 'rgba(0,0,0,.6)'}" stroke-width="1.2" rx="1.5"/>`;
  // brushed-sheen gradients for the metallic finishes (match the swatches)
  defs += `<linearGradient id="grMet" x1="0%" y1="0%" x2="80%" y2="100%">
      <stop offset="4%" stop-color="#eef0f2"/><stop offset="52%" stop-color="#a7aeb6"/>
      <stop offset="96%" stop-color="#d6dade"/></linearGradient>
    <linearGradient id="grGold" x1="0%" y1="0%" x2="80%" y2="100%">
      <stop offset="4%" stop-color="#ecd591"/><stop offset="52%" stop-color="#b58f3a"/>
      <stop offset="96%" stop-color="#dbc06e"/></linearGradient>`;
  const fillFor = col => col==='Metallic' ? 'url(#grMet)'
                       : col==='Gold' ? 'url(#grGold)'
                       : col ? (HEX[col]||'#888') : '#9aa1a9';
  const faceDefs = new Set();
  function ensureFace(key, blackish, slotted){
    const gid = 'f_' + key + (blackish ? '_d' : '_l') + (slotted ? '_s' : '');
    if(!faceDefs.has(gid)){
      faceDefs.add(gid);
      const inkRGB = blackish ? '255,255,255' : '0,0,0';
      const inkA   = blackish ? 0.55 : 0.5;
      const rim    = blackish ? 'rgba(255,255,255,.7)' : 'rgba(0,0,0,.6)';
      // geometricPrecision: peg holes and slots land near 1px on screen, and
      // the default "auto" lets the browser snap them to the pixel grid - some
      // columns then render crisp and full-opacity while their neighbours
      // straddle two pixels at half opacity, which reads as pale banding.
      defs += `<g id="${gid}" shape-rendering="geometricPrecision">${
        faceGroup(key, S, inkRGB, inkA, rim, pxPerUser, slotted)}</g>`;
    }
    return gid;
  }

  const pre=`<rect x="${PAD}" y="${PAD}" width="${w}" height="${h}" fill="none"
        stroke="var(--muted)" stroke-width="1.5" stroke-dasharray="5 4"/>`;

  /* The solver builds every layout from the bottom-left corner, but on a real
     wall you'd hang it centred, so shift the whole block by its own bounding box.
     Doing it here (rather than in the solver) keeps the plain and kit-anchored
     layouts consistent without touching the arithmetic behind them. */
  let x0=Infinity, x1=-Infinity, y0=Infinity, y1=-Infinity;
  for(const pl of placed){
    x0=Math.min(x0,pl.x); x1=Math.max(x1,pl.x+pl.w);
    y0=Math.min(y0,pl.y); y1=Math.max(y1,pl.y+pl.h);
  }
  const dx = placed.length ? (W-(x1-x0))/2 - x0 : 0;
  const dy = placed.length ? (H-(y1-y0))/2 - y0 : 0;

  for(const pl of placed){
    /* The V-Bracket module: front projection of two 16in panels angled 25.5deg
       into a V.  Each face compresses to ~6.9in; the dark centre strip is the
       end-cap gap where the panels meet. */
    if(pl.vmod){
      const x=PAD+(pl.x+dx)*S, y=PAD+h-(pl.y+dy+pl.h)*S, pw=pl.w*S, ph=pl.h*S;
      const c = fillFor(pl.panel.color);
      const vblackish = BLACKISH.includes(pl.panel.color);
      // the centre strip is the bracket hardware itself, so it follows the
      // bracket kit colour choice rather than the wall panels
      const bcol = pl.bracket || pl.panel.color;
      const bdark = !LIGHT.includes(bcol);
      const fw=(6.9/16)*pw, gap=(pw-1)-2*fw;
      fills+=panelFill(x, y, pw, ph, c);
      edges+=panelEdge(x, y, pw, ph, vblackish);
      // the real panel lattice on both faces, compressed to the 25.5deg front
      // projection; the right face is mirrored (its slots lean the other way)
      const vkey = faceKey(COL, pl.h);
      if(vkey){
        const gid = ensureFace(vkey, vblackish, state.face === 'slots');
        const sx = fw/(COL*S);
        body+=`<g transform="translate(${(x+.5).toFixed(2)},${(y+.5).toFixed(2)})
                scale(${sx.toFixed(4)},1)"><use href="#${gid}"/></g>`;
        body+=`<g transform="translate(${(x+.5+2*fw+gap).toFixed(2)},${(y+.5).toFixed(2)})
                scale(${(-sx).toFixed(4)},1)"><use href="#${gid}"/></g>`;
      }
      body+=`<rect x="${(x+.5+fw).toFixed(2)}" y="${y+.5}" width="${gap.toFixed(2)}"
              height="${ph-1}" fill="${fillFor(bcol)}"/>`;
      body+=`<rect x="${(x+.5+fw).toFixed(2)}" y="${y+.5}" width="${gap.toFixed(2)}"
              height="${ph-1}" fill="rgba(0,0,0,.3)"/>`;
      body+=`<rect x="${(x+.5+fw+gap).toFixed(2)}" y="${y+.5}" width="${fw.toFixed(2)}"
              height="${ph-1}" fill="rgba(0,0,0,.22)"/>`;
      if(ph>34) body+=`<text x="${x+pw/2}" y="${y+ph/2-2}" text-anchor="middle" font-size="11"
              fill="${bdark?'#fff':'#222'}" font-family="ui-monospace,monospace">3D V</text>
            <text x="${x+pw/2}" y="${y+ph/2+11}" text-anchor="middle" font-size="9"
              fill="${bdark?'rgba(255,255,255,.75)':'rgba(0,0,0,.6)'}"
              font-family="inherit">15&#8243; deep</text>`;
      continue;
    }
    // a kit follows the colour picker when it is sold in that finish; a
    // fixed-finish kit has no colour and draws neutral grey (see kitColor)
    const col = pl.panel.color;
    const c = fillFor(col);
    const dark = col ? !LIGHT.includes(col) : false;   // label/text colour only
    const blackish = BLACKISH.includes(col);
    // a 2-pack is physically two 16in panels side by side - draw the seam
    const pieces = pl.panel.pack>1 ? pl.panel.pack : 1;
    const pieceW = pl.w/pieces;

    for(let i=0;i<pieces;i++){
      const x=PAD+(pl.x+dx+i*pieceW)*S, y=PAD+h-(pl.y+dy+pl.h)*S,
            pw=pieceW*S, ph=pl.h*S;

      fills+=panelFill(x, y, pw, ph, c);
      edges+=panelEdge(x, y, pw, ph, blackish);

      // real traced face for this exact panel size, placed at its own corner
      const key = faceKey(pieceW, pl.h);
      if(key)
        body += `<use href="#${ensureFace(key, blackish, !!pl.panel.slotted)}" x="${x.toFixed(2)}" y="${y.toFixed(2)}"/>`;

      if(ph>17&&pw>44) body+=`<text x="${x+pw/2}" y="${y+ph/2+4}" text-anchor="middle"
            font-size="11" fill="${dark?'#fff':'#222'}"
            font-family="ui-monospace,monospace">${pl.h}&#215;${pieceW}</text>`;

      if(pl.kit) kitBox = kitBox
        ? {x0:Math.min(kitBox.x0,x), y0:Math.min(kitBox.y0,y),
           x1:Math.max(kitBox.x1,x+pw), y1:Math.max(kitBox.y1,y+ph)}
        : {x0:x, y0:y, x1:x+pw, y1:y+ph};
    }
  }
  let s=`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${w+PAD*2} ${h+PAD*2}">`
      + `<defs>${defs}</defs>` + pre + fills + body + edges;
  if(kitBox){
    s+=`<rect x="${kitBox.x0-2}" y="${kitBox.y0-2}" width="${kitBox.x1-kitBox.x0+4}"
          height="${kitBox.y1-kitBox.y0+4}" fill="none" stroke="#0d7a4a"
          stroke-width="2.5" rx="4"/>
        <rect x="${kitBox.x0+4}" y="${kitBox.y0+4}" width="30" height="15" rx="3" fill="#0d7a4a"/>
        <text x="${kitBox.x0+19}" y="${kitBox.y0+15}" text-anchor="middle" font-size="9.5"
          fill="#fff" font-family="inherit" font-weight="700">KIT</text>`;
  }
  s+=`<text x="${PAD+w/2}" y="${PAD+h+18}" text-anchor="middle" font-size="12"
        fill="var(--muted)" font-family="inherit">${W}" wide</text>`;
  s+=`<text x="12" y="${PAD+h/2}" text-anchor="middle" font-size="12" fill="var(--muted)"
        font-family="inherit" transform="rotate(-90 12 ${PAD+h/2})">${H}" tall</text>`;
  document.getElementById('svg').outerHTML = s+`</svg>`;
  // scope the re-tag to our own container: on a theme page document.querySelector('svg')
  // would grab the first header icon, not the freshly written diagram
  const drawn = document.getElementById('svgWrap').querySelector('svg');
  drawn.classList.add('wall');
  drawn.id = 'svg';
}

function tally(placed){
  const m=new Map();
  for(const pl of placed){
    if(pl.kit || pl.vmod) continue;   // kit and V-module are single line items
    const k=pl.panel.sku;
    if(!m.has(k)) m.set(k,{p:pl.panel,n:0});
    m.get(k).n++;
  }
  return [...m.values()].sort((a,b)=>b.n-a.n);
}

function drawLines(placed, T){
  const rows = [];
  if(T && T.kit) rows.push(`
    <tr><td><button type="button" class="qvline" data-qv="${T.kitVariant.sku}"><strong>${T.kit.title}</strong></button>
        ${T.accessories!=null?` <span class="sku">(${T.accessories} accessories)</span>`:''}
        <div class="sku">${T.kitVariant.sku}${T.kitVariant.accessoryColor
          ? ` · ${T.kitVariant.accessoryColor} accessories` : ''}</div></td>
      <td class="num">1</td><td class="num">${money(T.kitVariant.price)}</td></tr>`);
  const vb = state._vb;
  if(vb) rows.push(`
    <tr><td><button type="button" class="qvline" data-qv="${vb.bracket.sku}"><strong>${D.vbracket.title}</strong></button> <span class="sku">(${vb.h}in, ${vb.color})</span>
        <div class="sku">${vb.bracket.sku}</div></td>
      <td class="num">${vb.n}</td><td class="num">${money(vb.n*vb.bracket.price)}</td></tr>`);
  /* One consolidated line per SKU. The V faces are the same catalogue panels
     as the flat fill, so they fold into the matching line with a subtext
     count instead of their own "(the V pairs)" line. */
  const entries = [];
  if(T && T.kitUpgrade){
    // the pooled classes are repriced around the kit; everything else as drawn
    entries.push(...T.rebuys.map(({panel, qty}) => ({p: panel, n: qty})));
    entries.push(...tally(placed.filter(pl => pl.kit || pl.vmod
      || !T.needs.has(pieceClass(pl.panel)))));
  } else {
    entries.push(...tally(placed));
  }
  let vbNote = null;
  if(vb){
    const add = {p: vb.panel.p, n: vb.n*vb.panel.qty};
    const hit = entries.find(e => e.p.sku === add.p.sku);
    if(hit) hit.n += add.n; else entries.push(add);
    vbNote = {sku: add.p.sku, n: add.n, pairs: vb.n};
  }
  const row = (p, n) => `
    <tr><td><button type="button" class="qvline" data-qv="${p.sku}">${p.title}</button>${p.pack>1?` <span class="sku">(${p.pack}-pack)</span>`:''}
        <div class="sku">${p.sku}${vbNote && p.sku === vbNote.sku
          ? ` · ${vbNote.n} of these for the V-Bracket ${vbNote.pairs>1?'pairs':'pair'}` : ''}</div></td>
      <td class="num">${n}</td><td class="num">${money(p.price*n)}</td></tr>`;
  rows.push(...entries.map(e => row(e.p, e.n)));
  if(T) rows.push(`
    <tr><td style="border-top:2px solid var(--ink);padding-top:11px"><strong>Subtotal</strong></td>
      <td style="border-top:2px solid var(--ink)"></td>
      <td class="num" style="border-top:2px solid var(--ink);padding-top:11px">
        <strong>${money(T.cost)}</strong></td></tr>`);
  document.getElementById('lines').innerHTML = rows.join('');
  document.querySelectorAll('#lines [data-qv]').forEach(b =>
    b.onclick = () => showQuickView(b.dataset.qv));
}
/* ----------------------------------------------------- line-item quick view */
/* Resolve whichever catalogue record carries this SKU into a uniform shape. */
function qvRecord(sku){
  const p = D.panels.find(x => x.sku === sku);
  if(p) return {title:p.title, image:p.image, handle:p.handle, sku, price:p.price,
    meta:[`${pieceW(p)}&Prime; wide × ${p.height}&Prime; tall${
      p.pack>1 ? ` — sold as a ${p.pack}-pack` : ''}`, p.color]};
  for(const kit of D.kits){
    const kv = (kit.variants||[]).find(v => v.sku === sku);
    if(kv) return {title:kit.title, image:kit.image, handle:kit.handle, sku, price:kv.price,
      meta:[`${kitPanelsDesc(kit) ? kitPanelsDesc(kit) + ' panels'
          : `${kit.width}&Prime; × ${kit.height}&Prime; footprint`}${
        kit.accessories!=null ? ` — ${kit.accessories} accessories` : ''}`,
        [kv.pegboardColor && `${kv.pegboardColor} pegboard`,
         kv.accessoryColor && `${kv.accessoryColor} accessories`].filter(Boolean).join(', ')]};
  }
  if(D.vbracket) for(const h of Object.keys(D.vbracket.heights))
    for(const [col, b] of Object.entries(D.vbracket.heights[h]))
      if(b.sku === sku)
        return {title:D.vbracket.title, image:b.image || D.vbracket.image,
          handle:D.vbracket.handle, sku, price:b.price,
          meta:[`${h}&Prime; tall faces, ${D.vbracket.depth}&Prime; deep`, col]};
  return null;
}
function showQuickView(sku){
  const r = qvRecord(sku);
  if(!r) return;
  // title, image and the details button all open the listing in a new tab
  const url = `/products/${r.handle}`;
  document.getElementById('dlgTitle').innerHTML =
    `<a class="qvtitle" href="${url}" target="_blank" rel="noopener">${r.title}</a>`;
  document.getElementById('dlgBody').innerHTML = `
    <div class="qv">
      ${r.image ? `<a class="qvimg" href="${url}" target="_blank" rel="noopener"
          aria-label="View ${r.title} in a new tab"><img src="${r.image}" alt=""></a>` : ''}
      <div class="qv-info">
        ${r.meta.filter(Boolean).map(m => `<span>${m}</span>`).join('')}
        <span class="sku">${r.sku}</span>
        <b>${money(r.price)}</b>
        <a class="qvlink" href="${url}" target="_blank" rel="noopener">View full product details
          <span aria-hidden="true">&#8599;</span></a>
      </div>
    </div>`;
  document.getElementById('dlg').showModal();
}


function showKitContents(T, box){
  const k = T.kit, v = T.kitVariant;
  const bom = k.bom && k.bom.length
    ? `<p style="margin:8px 0 0;font-size:13px">Includes ${k.bom.slice(0,6)
        .map(b=>`<strong>${b.qty}&times;</strong> ${b.item}`).join(', ')}${
        k.bom.length>6?', and more':''}.</p>`
    : `<p style="margin:8px 0 0;font-size:13px">This listing doesn't itemise its
        accessories &mdash; check the product page for what's included.</p>`;
  const choices = kitAccessoryChoices(k);
  const accPick = kitAccessoryPicked(k);
  const nag = state.accWarn === k.handle && !accPick;
  const picker = choices.length > 1 ? `
    <div style="margin-top:12px" id="kitAccPick">
      <span style="font-size:11px;color:var(--muted);text-transform:uppercase;letter-spacing:.6px">
        Accessory finish: <b style="color:${nag ? 'var(--accent)' : 'var(--ink)'}">${
          accPick || 'choose a color'}</b></span>
      <div class="swatches" style="margin-top:7px">
        ${choices.map(c=>`<button class="sw" data-kacc="${c}" title="${c} accessories"
          aria-label="${c} accessories" aria-pressed="${c===accPick}"><i style="background:${
            HEX[c] || '#888'}"></i></button>`).join('')}
      </div>
      ${nag ? `<p style="margin:7px 0 0;font-size:12.5px;color:var(--accent);font-weight:600">
        Pick an accessory finish to add this kit to your cart.</p>` : ''}
    </div>` : '';
  const tag = T.kitUpgrade
    ? (T.delta <= 0
        ? `Upgrade to the kit and save ${money(-T.delta)} &mdash; accessories included`
        : `${money(T.delta)} more upgrades these panels to the kit${
            T.accessories != null ? ` with ${T.accessories} accessories` : ''}`)
    : 'Kit-first build &mdash; most accessories for your money';
  box.innerHTML = `<div class="kit">
    <div class="tag">${tag}</div>
    <p><strong>${k.title}</strong> &mdash; ${money(v.price)}</p>
    ${bom}
    <p style="margin:8px 0 0;font-size:12.5px;color:var(--muted)">${finishNote(k, v)}</p>
    ${picker}
  </div>`;
  box.querySelectorAll('[data-kacc]').forEach(b=>b.onclick=()=>{
    state.kitAccessory.set(k.handle, b.dataset.kacc);
    state.accWarn = null;
    render();
  });
}

function suggestKit(T, W, H, box){
  if(state.face === 'slots'){ box.innerHTML = ''; return; }
  // Stock kits bundle hooks and accessories, so they rarely beat bare panels on
  // raw price.  Surface one whenever it fits the wall and lands in a comparable
  // price band, and state the difference plainly rather than claiming it is cheaper.
  const cands = D.kits.filter(kitOffered).map(k => ({kit:k, variant:kitVariant(k), area:k.width*k.height}))
    .filter(x => x.variant && x.kit.width<=W && x.kit.height<=H)
    .filter(x => x.area >= T.covered*0.8 && x.variant.price <= T.cost*1.75);
  if(!cands.length){ box.innerHTML=''; return; }
  const x = cands.reduce((a,b)=> b.area/b.variant.price > a.area/a.variant.price ? b : a);
  const k = x.kit, v = x.variant;
  const diff = v.price - T.cost;
  const cmp = diff > 0
    ? `<strong>${money(diff)} more</strong> than the ${money(T.cost)} panel-only build above,
       but it also includes the hooks and accessories to actually hang your tools`
    : `<strong>${money(-diff)} less</strong> than the ${money(T.cost)} panel-only build above,
       and it includes hooks and accessories as well`;
  box.innerHTML = `<div class="kit">
    <div class="tag">A ready-made kit covers this wall too</div>
    <p><strong>${k.title}</strong></p>
    <p>Covers ${k.width}&Prime; × ${k.height}&Prime; for <strong>${money(v.price)}</strong> — ${cmp}.</p>
    <p style="margin:8px 0 0;font-size:12.5px;color:var(--muted)">${finishNote(k, v)}</p>
  </div>`;
}

/* One toggle per distinct panel in the chosen colour, so a customer can rule out
   sizes they don't want (or the pricier Signature Series) and re-solve. */
function drawToggles(inColour){
  const groups = new Map();
  for(const p of inColour){
    const k = sizeKey(p);
    if(!groups.has(k)) groups.set(k, []);
    groups.get(k).push(p);
  }
  const rows = [...groups.entries()].map(([k, ps])=>{
    ps.sort((a,b)=> a.price/a.pack - b.price/b.pack);   // best value per panel first
    return {k, best:ps[0], single:ps.find(p=>p.pack===1) || ps[0],
            w:pieceW(ps[0]), h:ps[0].height, sig:ps.some(p=>p.signature)};
  }).sort((a,b)=> a.w-b.w || a.h-b.h);

  document.getElementById('panelToggles').innerHTML = rows.map(r=>{
    const packDeal = r.best.pack > 1
      ? ` <em>${r.best.pack}-pack ${money(r.best.price/r.best.pack)} ea</em>` : '';
    return `<label class="tog${state.off.has(r.k)?' gone':''}">
      <input type="checkbox" data-key="${r.k}" ${state.off.has(r.k)?'':'checked'}>
      <span>${sizeName(r.h, r.w)}${r.sig?' <em>Signature</em>':''}${packDeal}</span>
      <b>${money(r.single.price)}</b></label>`;
  }).join('');

  document.querySelectorAll('.tog input').forEach(cb=>cb.onchange=()=>{
    if(cb.checked) state.off.delete(cb.dataset.key);
    else           state.off.add(cb.dataset.key);
    render();
  });
}

function payload(){
  const [W,H]=inches();
  const panels=D.panels.filter(p=>p.color===state.color && !state.off.has(sizeKey(p))
    && !!p.slotted === (state.face === 'slots'));
  const T=state.tiers[state.tier]; if(!T) return null;
  const vb = state._vb;
  const segs = vbSegments(vb, Math.floor(W/COL));
  const plan = (segs.length || vb) ? solveSplit(panels, segs, H, vb) : null;
  if(!plan && !vb) return null;
  const items = T.kit ? [{sku:T.kitVariant.sku, handle:T.kit.handle, quantity:1}] : [];
  const placed = (T.vbOnly || !plan) ? []
               : (T.kit && T.kitAnchor) ? layoutKit(T)
               : layoutPlan(plan, T.height, T.cfg);
  if(vb){
    items.push({sku:vb.bracket.sku, handle:D.vbracket.handle, quantity:vb.n});
    items.push({sku:vb.panel.p.sku, handle:vb.panel.p.handle, quantity:vb.n*vb.panel.qty});
  }
  if(T.kitUpgrade){
    items.push(...T.rebuys.map(({panel, qty}) => ({sku:panel.sku, handle:panel.handle, quantity:qty})));
    items.push(...tally(placed.filter(pl => !T.needs.has(pieceClass(pl.panel))))
      .map(({p,n}) => ({sku:p.sku, handle:p.handle, quantity:n})));
  } else {
    items.push(...tally(placed).map(({p,n}) => ({sku:p.sku, handle:p.handle, quantity:n})));
  }
  // one line per SKU: the same panel can arrive from several sources (V pairs,
  // repriced pools, plain fills) and the eventual cart request wants them merged
  const merged = new Map();
  for(const it of items){
    if(merged.has(it.sku)) merged.get(it.sku).quantity += it.quantity;
    else merged.set(it.sku, {...it});
  }
  return [...merged.values()];
}

/* --------------------------------------------------- shareable plan state
   One serializable object powers three planned features: save/share links,
   email capture, and purchase attribution (HANDOFF roadmap items 4-5). Keep
   it stable and compact - it will eventually ride cart attributes verbatim. */
function planState(){
  const [W,H] = inches();
  return {v:1, w:W, h:H, color:state.color, face:state.face,
          off:[...state.off].sort(),
          budget:[state.budget.min, state.budget.max],
          vb: state.vb.on ? {h:state.vb.h, n:state.vb.n, c:state.vb.color} : null,
          kit: state.kitPick,
          acc: [...state.kitAccessory],
          tier: state.tier, tn: state.tiers[state.tier]?.name ?? null, pick: state.pick};
}
function encodePlan(){
  return btoa(unescape(encodeURIComponent(JSON.stringify(planState()))))
    .replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
}
/* The URL always carries the current plan, so a reload (or a bookmark) after
   editing a shared plan restores the edits rather than the original link. */
function syncPlanHash(){
  if(!state.dims) return;
  try{ history.replaceState(null, '', location.pathname + location.search + '#p=' + encodePlan()); }
  catch(e){}
}
function applyPlan(enc){
  let s;
  try{
    s = JSON.parse(decodeURIComponent(escape(atob(
      enc.replace(/-/g,'+').replace(/_/g,'/')))));
  }catch(e){ return false; }
  if(!s || s.v !== 1 || !(s.w > 0) || !(s.h > 0)) return false;
  state.dims = {w: Math.min(s.w, MAX_W), h: Math.min(s.h, MAX_H)};
  const [bmin, bmax] = s.budget || [null, null];
  state.color = s.color || 'Black';
  state.face = s.face === 'slots' ? 'slots' : 'dots';
  state.off = new Set(s.off || []);
  state.budget = {min: bmin ?? null, max: bmax ?? null};
  state.vb = s.vb ? {on:true, h:s.vb.h, n:s.vb.n, color:s.vb.c ?? null}
                  : {on:false, h:32, n:1, color:null};
  state.kitPick = KITS_ON ? (s.kit || null) : null;
  state.kitAccessory = new Map(s.acc || []);
  state.tier = s.tier || 0;
  state._tierName = s.tn || null;
  state.pick = s.pick ?? null;
  return true;
}

/* Payload inspector — the button is no longer in the markup, but the handler
   stays bound if a page (e.g. a debug build) adds `#showPayload` back. */
const showPayloadBtn=document.getElementById('showPayload');
if(showPayloadBtn) showPayloadBtn.onclick=()=>{
  const items=payload(); if(!items) return;
  document.getElementById('dlgTitle').textContent='Cart request (simulated)';
  document.getElementById('dlgBody').innerHTML=`
    <p style="margin:0 0 10px;font-size:13.5px;color:var(--muted)">
      In the theme, Liquid renders each variant's numeric <code>id</code> alongside its SKU, so this
      becomes a single <code>POST /cart/add.js</code>. Nothing has been sent.</p>
    <pre>${JSON.stringify({items:items.map(i=>({
        id:(window.PLANNER_VARIANT_IDS||{})[i.sku] || '«variant id for '+i.sku+'»',
        quantity:i.quantity})),
        attributes:{wc_planner:'1', wc_plan:encodePlan()}},null,2)}</pre>
    <p style="margin:10px 0 0;font-size:13.5px;color:var(--muted)">Resolved from:</p>
    <pre>${items.map(i=>`${i.sku.padEnd(16)} x${i.quantity}  /products/${i.handle}`).join('\n')}</pre>
    <p style="margin:10px 0 0;font-size:13.5px;color:var(--muted)">
      <code>attributes.wc_plan</code> is the same encoding the share link uses — it marks the
      order as a planner purchase and preserves the plan for later remarketing.</p>`;
  document.getElementById('dlg').showModal();
};
/* The real cart flow (theme only, opt-in via the section's cart_mode setting).
   Two requests: /cart/add.js takes the items but IGNORES top-level attributes,
   so /cart/update.js follows to record the planner attribution - wc_planner
   flags the order, wc_plan carries the share-link plan encoding. Both land on
   the order as note attributes for reporting and remarketing. */
async function addAllToCart(items){
  const ids = window.PLANNER_VARIANT_IDS || {};
  const btn = document.getElementById('addAll');
  const old = btn.textContent;
  btn.disabled = true; btn.textContent = 'Adding…';
  try{
    const add = await fetch('/cart/add.js', {method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({items: items.map(i =>
        ({id: Number(ids[i.sku]), quantity: i.quantity}))})});
    if(!add.ok){
      const err = await add.json().catch(()=>({}));
      throw new Error(err.description || err.message || ('cart/add.js ' + add.status));
    }
    await fetch('/cart/update.js', {method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify({attributes:
        {wc_planner:'1', wc_plan: encodePlan()}})});
    window.location.href = '/cart';
  }catch(e){
    btn.disabled = false; btn.textContent = old;
    document.getElementById('dlgTitle').textContent = 'Could not add to cart';
    document.getElementById('dlgBody').innerHTML = `
      <p style="font-size:14px;margin:0">${String(e.message || e)}</p>
      <p style="font-size:13px;margin:8px 0 0" class="note">Nothing was charged — the
      cart request failed. Please try again.</p>`;
    document.getElementById('dlg').showModal();
  }
}
document.getElementById('addAll').onclick=()=>{
  // a kit with an accessory choice must have one picked before anything is added
  const T = state.tiers[state.tier];
  if(T && T.kit && !kitAccessoryChosen(T.kit)){
    state.accWarn = T.kit.handle; render();
    const pick = document.getElementById('kitAccPick');
    if(pick) pick.scrollIntoView({behavior:'smooth', block:'center'});
    return;
  }
  const items = payload();
  const ids = window.PLANNER_VARIANT_IDS || {};
  if(window.PLANNER_CART_MODE === 'live' && items && items.length
     && items.every(i => ids[i.sku])){
    addAllToCart(items);
    return;
  }
  document.getElementById('dlgTitle').textContent='Simulated — nothing was added';
  document.getElementById('dlgBody').innerHTML=`
    <p style="font-size:14px;margin:0">This prototype is deliberately not wired to the live
    storefront. In production this button posts the item list to <code>/cart/add.js</code>
    and opens the cart drawer.</p>`;
  document.getElementById('dlg').showModal();
};

/* Copy a shareable link (under Add to cart): the label span swaps to a
   confirmation and back; the link icon before it stays put. */
const shareLbl = document.querySelector('#sharePlan span');
const SHARE_LABEL = shareLbl.textContent;
document.getElementById('sharePlan').onclick = async ()=>{
  const btn = document.getElementById('sharePlan');
  const url = location.href.split('#')[0] + '#p=' + encodePlan();
  try{ await navigator.clipboard.writeText(url); }
  catch(e){ prompt('Copy this link:', url); }
  shareLbl.textContent = 'Link copied — restores this exact plan';
  clearTimeout(btn._t);
  btn._t = setTimeout(()=>{ shareLbl.textContent = SHARE_LABEL; }, 2400);
};

/* ------------------------------------------------------------ diagram zoom
   The wall diagram zooms inside its fixed viewport: pinch on touch, +/− and
   Reset buttons, double-tap/double-click, ctrl+wheel on trackpads. Once
   zoomed in, a single finger or mouse drag pans; at 1x single-finger touches
   fall through to page scrolling (touch-action: pan-y). The transform sits on
   the #svgZoom wrapper rather than the <svg> itself, so draw() replacing the
   svg keeps the zoom, and draw() measures #svgWrap, which never transforms. */
window.wallZoom = (()=>{
  const wrap = document.getElementById('svgWrap');
  const inner = document.getElementById('svgZoom');
  if(!wrap || !inner) return {reset(){}};
  const MIN = 1, MAX = 6, EPS = 1.001;
  let s = 1, tx = 0, ty = 0;
  const ptrs = new Map();          // pointerId -> {x, y} (client px)
  let pinch = null, drag = null;
  function apply(){
    const W = wrap.clientWidth, H = wrap.clientHeight;
    tx = Math.min(0, Math.max(W - W*s, tx));   // never show past the edges
    ty = Math.min(0, Math.max(H - H*s, ty));
    inner.style.transform = `translate(${tx}px,${ty}px) scale(${s})`;
    wrap.classList.toggle('zoomed', s > EPS);
    const r = wrap.querySelector('[data-zoom=reset]');
    if(r) r.hidden = s <= EPS;
  }
  function reset(){ s = 1; tx = ty = 0; apply(); }
  function local(x, y){ const b = wrap.getBoundingClientRect(); return [x - b.left, y - b.top]; }
  function zoomAt(f, cx, cy){   // cx, cy in wrap px; that point stays put
    const ns = Math.min(MAX, Math.max(MIN, s*f));
    if(ns === s) return;
    tx = cx - (cx - tx) * ns/s;
    ty = cy - (cy - ty) * ns/s;
    s = ns; apply();
  }
  wrap.addEventListener('click', e=>{
    const b = e.target.closest('[data-zoom]'); if(!b) return;
    const cx = wrap.clientWidth/2, cy = wrap.clientHeight/2;
    if(b.dataset.zoom === 'in') zoomAt(1.5, cx, cy);
    else if(b.dataset.zoom === 'out') zoomAt(1/1.5, cx, cy);
    else reset();
  });
  wrap.addEventListener('dblclick', e=>{
    if(e.target.closest('[data-zoom]')) return;
    e.preventDefault();
    const [x, y] = local(e.clientX, e.clientY);
    if(s > EPS) reset(); else zoomAt(2.5, x, y);
  });
  wrap.addEventListener('wheel', e=>{
    if(!e.ctrlKey) return;              // trackpad pinch / ctrl+wheel only
    e.preventDefault();
    const [x, y] = local(e.clientX, e.clientY);
    zoomAt(e.deltaY < 0 ? 1.15 : 1/1.15, x, y);
  }, {passive:false});
  wrap.addEventListener('pointerdown', e=>{
    if(e.target.closest('[data-zoom]')) return;
    ptrs.set(e.pointerId, {x:e.clientX, y:e.clientY});
    try{ wrap.setPointerCapture(e.pointerId); }catch(err){}
    if(ptrs.size === 2){
      const [a, b] = [...ptrs.values()];
      const [cx, cy] = local((a.x+b.x)/2, (a.y+b.y)/2);
      pinch = {d:Math.hypot(a.x-b.x, a.y-b.y), s0:s, cx, cy, tx0:tx, ty0:ty};
      drag = null; wrap.classList.remove('drag');
    }else if(ptrs.size === 1 && s > EPS){
      drag = {x:e.clientX, y:e.clientY, tx0:tx, ty0:ty};
      wrap.classList.add('drag');
    }
  });
  wrap.addEventListener('pointermove', e=>{
    const p = ptrs.get(e.pointerId); if(!p) return;
    p.x = e.clientX; p.y = e.clientY;
    if(pinch && ptrs.size === 2){
      const [a, b] = [...ptrs.values()];
      const d = Math.hypot(a.x-b.x, a.y-b.y) || pinch.d;
      const ns = Math.min(MAX, Math.max(MIN, pinch.s0 * d/pinch.d));
      const [cx, cy] = local((a.x+b.x)/2, (a.y+b.y)/2);
      // the diagram point that was under the first midpoint follows the fingers
      tx = cx - (pinch.cx - pinch.tx0) * ns/pinch.s0;
      ty = cy - (pinch.cy - pinch.ty0) * ns/pinch.s0;
      s = ns; apply();
    }else if(drag){
      tx = drag.tx0 + (e.clientX - drag.x);
      ty = drag.ty0 + (e.clientY - drag.y);
      apply();
    }
  });
  const up = e=>{
    if(!ptrs.delete(e.pointerId)) return;
    if(ptrs.size < 2) pinch = null;
    if(ptrs.size === 1 && s > EPS){
      // lifting one pinch finger hands over to a pan with the other
      const p = [...ptrs.values()][0];
      drag = {x:p.x, y:p.y, tx0:tx, ty0:ty}; wrap.classList.add('drag');
    }
    if(!ptrs.size){ drag = null; wrap.classList.remove('drag'); }
  };
  wrap.addEventListener('pointerup', up);
  wrap.addEventListener('pointercancel', up);
  window.addEventListener('resize', apply);
  return {reset};
})();

/* ------------------------------------------------------------------- init */
// a shared plan link restores the full configuration before first render
if(location.hash.startsWith('#p=')) applyPlan(location.hash.slice(3));
const rank = c => { const i = SWATCH_ORDER.indexOf(c); return i<0 ? 99 : i; };
const colors=[...new Set(D.panels.map(p=>p.color))]
  .sort((a,b)=> rank(a)-rank(b) ||
     D.panels.filter(p=>p.color===b).length - D.panels.filter(p=>p.color===a).length);
document.getElementById('swatches').innerHTML = colors.map(c=>
  `<button class="sw" data-c="${c}" title="${c}" aria-label="${c}"
     aria-pressed="${c===state.color}"><i style="background:${
       GRAD[c] || HEX[c] || '#888'}"></i></button>`).join('');
function setColorName(){ document.getElementById('colorPick').textContent = state.color; }
document.querySelectorAll('.sw').forEach(b=>b.onclick=()=>{
  if(b.classList.contains('na')) return;
  state.color=b.dataset.c;
  document.querySelectorAll('.sw').forEach(x=>x.setAttribute('aria-pressed', x===b));
  setColorName();
  render();
});
setColorName();
document.querySelectorAll('#facePick button').forEach(b=>b.onclick=()=>{
  if(state.face === b.dataset.face) return;
  state.face = b.dataset.face;
  const avail = new Set(D.panels
    .filter(p => !!p.slotted === (state.face === 'slots')).map(p => p.color));
  if(!avail.has(state.color)){
    state.color = SWATCH_ORDER.find(c => avail.has(c)) || [...avail][0];
    document.querySelectorAll('.sw').forEach(x =>
      x.setAttribute('aria-pressed', x.dataset.c === state.color));
    setColorName();
  }
  state.kitPick = null;          // the face switch changes the whole palette
  state.tier = 0; state.pick = null; render();
});
/* Wall size and budget are edited only through their dialogs. Each dialog
   is seeded from state when opened (so share links and resets need no input
   bookkeeping) and commits on its Apply button, never per keystroke. */
const setVal = (id, val) => { document.getElementById(id).value = val; };
function seedDimsDlg(){
  const d = state.dims || {w:96, h:48};
  setVal('dwft', Math.floor(d.w/12)); setVal('dwin', d.w%12);
  setVal('dhft', Math.floor(d.h/12)); setVal('dhin', d.h%12);
  document.getElementById('dimsDlgNote').textContent = '';
}
function seedBudgetDlg(){
  const {min, max} = state.budget;
  setVal('dbmin', min != null ? min/100 : '');
  setVal('dbmax', max != null ? max/100 : '');
  showBudgetMin(min != null);     // the minimum only surfaces once it's in use
}
function showBudgetMin(on){
  document.getElementById('budgetMinWrap').hidden = !on;
  document.getElementById('budgetMinToggle').hidden = on;
}
document.getElementById('budgetMinToggle').onclick = ()=>{
  showBudgetMin(true); document.getElementById('dbmin').focus();
};
/* "More options" fold: Reset clears both power-user controls without
   toggling the fold (the button sits inside the summary). */
document.getElementById('resetMore').onclick = e=>{
  e.preventDefault(); e.stopPropagation();
  state.off.clear();
  state.vb = {on:false, h:32, n:1, color:null};
  state.tier = 0; state.pick = null; render();
};
document.getElementById('editDims').onclick = ()=>{
  seedDimsDlg(); document.getElementById('dimsDlg').showModal();
};
document.getElementById('dimsDlgGo').onclick = ()=>{
  const d = dimsFrom(['dwft','dwin','dhft','dhin']);
  if(tryApplyDims(d, document.getElementById('dimsDlgNote')))
    document.getElementById('dimsDlg').close();
};
['dwft','dwin','dhft','dhin'].forEach(id=>
  document.getElementById(id).addEventListener('keydown', e=>{
    if(e.key === 'Enter') document.getElementById('dimsDlgGo').click();
  }));
document.getElementById('editBudget').onclick = ()=>{
  seedBudgetDlg(); document.getElementById('budgetDlg').showModal();
};
function applyBudget(min, max){
  state.budget = {min, max};
  state.tier = 0; state.pick = null; render();
  document.getElementById('budgetDlg').close();
}
document.getElementById('budgetDlgGo').onclick = ()=>{
  const cents = id => {                                        // dollars in the field
    const v = parseFloat(document.getElementById(id).value);
    return isFinite(v) && v > 0 ? Math.round(v*100) : null;    // cents in the state
  };
  applyBudget(cents('dbmin'), cents('dbmax'));
};
document.getElementById('budgetDlgClear').onclick = ()=> applyBudget(null, null);
['dbmin','dbmax'].forEach(id=>
  document.getElementById(id).addEventListener('keydown', e=>{
    if(e.key === 'Enter') document.getElementById('budgetDlgGo').click();
  }));
/* Per-setting resets are optional in the markup (the settings row relies on
   the dialogs' own controls and Reset all); bind them only if present. */
const resetDimsBtn = document.getElementById('resetDims');
if(resetDimsBtn) resetDimsBtn.onclick = ()=>{
  state.dims = {w:96, h:48};
  state.tier = 0; state.pick = null; render();
};
const resetBudgetBtn = document.getElementById('resetBudget');
if(resetBudgetBtn) resetBudgetBtn.onclick = ()=>{
  state.budget = {min:null, max:null};
  state.tier = 0; state.pick = null; render();
};
document.getElementById('resetAll').onclick = ()=>{
  state.color = 'Black';
  state.face = 'dots';
  state.budget = {min:null, max:null};
  state.off.clear();
  state.vb = {on:false, h:32, n:1, color:null};
  state.kitAccessory.clear();
  state.accWarn = null;
  state.kitPick = null;
  state.dims = {w:96, h:48};
  state.pick = null; state.tier = 0; state.combosOpen = false;
  document.querySelectorAll('.sw').forEach(x =>
    x.setAttribute('aria-pressed', x.dataset.c === state.color));
  setColorName();
  render();
};
render();
// a restored plan that uses the power-user controls opens the fold so they're
// visible from the start
if(state.off.size || state.vb.on) document.getElementById('moreOpts').open = true;

/* First visit (no share-link plan restored): ask for the wall size up front. */
if(!state.dims){ seedDimsDlg(); document.getElementById('dimsDlg').showModal(); }
